/*
IMPORTANT
This file is auto-generated.
Do not make manual changes.
Manual changes will be overwritten when the file is next generated.

API:          IBSS API
Version:      1
Description:  IBSS API provides app calls for mobile and panel apps.
Generated at: 23-06-2025 15:19 (India Standard Time)
*/

import axios, { AxiosError, AxiosResponse } from 'axios';
import { ApiError } from '../Providers.Api/ApiError';
import { ODataSelect } from '../Providers.Api/ODataQuery';
import { IRawPagedResponse, IRawPagedResponse3, PagedResponse } from '../Providers.Api/Models';
import { ApiHelper } from '../Providers.Api/ApiHelper';
import { IbssRequestConfig } from '../Providers.Api/ApiClient';

export interface IContext
{
    baseUrl: string;
}

export interface IIbssApiClientV1
{
    v1: IIbssApiClientV1_V1;


}

export class IbssApiClientV1 implements IIbssApiClientV1
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.v1 = new IbssApiClientV1_V1(context);
    }

    public v1: IbssApiClientV1_V1;


}

export interface IIbssApiClientV1_V1
{
    auth: IIbssApiClientV1_V1_Auth;
    byNodeid: IIbssApiClientV1_V1_ByNodeid;
    delegates: IIbssApiClientV1_V1_Delegates;
    devices: IIbssApiClientV1_V1_Devices;
    notificationHubRegister: IIbssApiClientV1_V1_NotificationHubRegister;
    organisations: IIbssApiClientV1_V1_Organisations;
    service: IIbssApiClientV1_V1_Service;
    spacesDailySummary: IIbssApiClientV1_V1_SpacesDailySummary;
    spacesSummary: IIbssApiClientV1_V1_SpacesSummary;
    users: IIbssApiClientV1_V1_Users;


}

export class IbssApiClientV1_V1 implements IIbssApiClientV1_V1
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.auth = new IbssApiClientV1_V1_Auth(context);
        this.byNodeid = new IbssApiClientV1_V1_ByNodeid(context);
        this.delegates = new IbssApiClientV1_V1_Delegates(context);
        this.devices = new IbssApiClientV1_V1_Devices(context);
        this.notificationHubRegister = new IbssApiClientV1_V1_NotificationHubRegister(context);
        this.organisations = new IbssApiClientV1_V1_Organisations(context);
        this.service = new IbssApiClientV1_V1_Service(context);
        this.spacesDailySummary = new IbssApiClientV1_V1_SpacesDailySummary(context);
        this.spacesSummary = new IbssApiClientV1_V1_SpacesSummary(context);
        this.users = new IbssApiClientV1_V1_Users(context);
    }

    public auth: IbssApiClientV1_V1_Auth;
    public byNodeid: IbssApiClientV1_V1_ByNodeid;
    public delegates: IbssApiClientV1_V1_Delegates;
    public devices: IbssApiClientV1_V1_Devices;
    public notificationHubRegister: IbssApiClientV1_V1_NotificationHubRegister;
    public organisations: IbssApiClientV1_V1_Organisations;
    public service: IbssApiClientV1_V1_Service;
    public spacesDailySummary: IbssApiClientV1_V1_SpacesDailySummary;
    public spacesSummary: IbssApiClientV1_V1_SpacesSummary;
    public users: IbssApiClientV1_V1_Users;


}

export interface IIbssApiClientV1_V1_Auth
{
    rights: IIbssApiClientV1_V1_Auth_Rights;
    rights2: IIbssApiClientV1_V1_Auth_Rights2;

    get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { body: IAuthenticateRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_Auth implements IIbssApiClientV1_V1_Auth
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.rights = new IbssApiClientV1_V1_Auth_Rights(context);
        this.rights2 = new IbssApiClientV1_V1_Auth_Rights2(context);
    }

    public rights: IbssApiClientV1_V1_Auth_Rights;
    public rights2: IbssApiClientV1_V1_Auth_Rights2;


    public async get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/Auth?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { body: IAuthenticateRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v1/Auth?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_Auth_Rights
{

    get<TResponse>(options: { clientId?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_Auth_Rights implements IIbssApiClientV1_V1_Auth_Rights
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { clientId?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.clientId) { queryParts.push(`clientId=${encodeURIComponent(options.clientId)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/Auth/rights?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_Auth_Rights2
{

    get<TResponse>(options: { application?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_Auth_Rights2 implements IIbssApiClientV1_V1_Auth_Rights2
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { application?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.application) { queryParts.push(`application=${encodeURIComponent(options.application)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/Auth/rights2?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid
{
    bookingParties: IIbssApiClientV1_V1_ByNodeid_BookingParties;
    bookings: IIbssApiClientV1_V1_ByNodeid_Bookings;
    bookingsDailySummary: IIbssApiClientV1_V1_ByNodeid_BookingsDailySummary;
    buildingKpis: IIbssApiClientV1_V1_ByNodeid_BuildingKpis;
    buildings: IIbssApiClientV1_V1_ByNodeid_Buildings;
    connectors: IIbssApiClientV1_V1_ByNodeid_Connectors;
    costCodes: IIbssApiClientV1_V1_ByNodeid_CostCodes;
    environmentalSensors: IIbssApiClientV1_V1_ByNodeid_EnvironmentalSensors;
    environmentalZoneDailySummary: IIbssApiClientV1_V1_ByNodeid_EnvironmentalZoneDailySummary;
    environmentalZoneData: IIbssApiClientV1_V1_ByNodeid_EnvironmentalZoneData;
    environmentalZones: IIbssApiClientV1_V1_ByNodeid_EnvironmentalZones;
    environmentalZoneSummary: IIbssApiClientV1_V1_ByNodeid_EnvironmentalZoneSummary;
    equipment: IIbssApiClientV1_V1_ByNodeid_Equipment;
    floors: IIbssApiClientV1_V1_ByNodeid_Floors;
    languages: IIbssApiClientV1_V1_ByNodeid_Languages;
    lockers: IIbssApiClientV1_V1_ByNodeid_Lockers;
    nodes: IIbssApiClientV1_V1_ByNodeid_Nodes;
    notifications: IIbssApiClientV1_V1_ByNodeid_Notifications;
    parameters: IIbssApiClientV1_V1_ByNodeid_Parameters;
    regions: IIbssApiClientV1_V1_ByNodeid_Regions;
    resolversCategories: IIbssApiClientV1_V1_ByNodeid_ResolversCategories;
    resolversDailySummary: IIbssApiClientV1_V1_ByNodeid_ResolversDailySummary;
    signage: IIbssApiClientV1_V1_ByNodeid_Signage;
    spaceCateringMenu: IIbssApiClientV1_V1_ByNodeid_SpaceCateringMenu;
    spaces: IIbssApiClientV1_V1_ByNodeid_Spaces;
    spacesDailySummary: IIbssApiClientV1_V1_ByNodeid_SpacesDailySummary;
    spacesSummary: IIbssApiClientV1_V1_ByNodeid_SpacesSummary;
    spaceStates: IIbssApiClientV1_V1_ByNodeid_SpaceStates;
    spaceUtilisation: IIbssApiClientV1_V1_ByNodeid_SpaceUtilisation;
    spaceZones: IIbssApiClientV1_V1_ByNodeid_SpaceZones;
    supportedVersions: IIbssApiClientV1_V1_ByNodeid_SupportedVersions;
    taskCategories: IIbssApiClientV1_V1_ByNodeid_TaskCategories;
    tasks: IIbssApiClientV1_V1_ByNodeid_Tasks;
    tasksDailySummary: IIbssApiClientV1_V1_ByNodeid_TasksDailySummary;
    taskStates: IIbssApiClientV1_V1_ByNodeid_TaskStates;
    taskTypes: IIbssApiClientV1_V1_ByNodeid_TaskTypes;
    trackAndTrace: IIbssApiClientV1_V1_ByNodeid_TrackAndTrace;
    userNotifications: IIbssApiClientV1_V1_ByNodeid_UserNotifications;
    userPreferences: IIbssApiClientV1_V1_ByNodeid_UserPreferences;
    visits: IIbssApiClientV1_V1_ByNodeid_Visits;
    visitsDailySummary: IIbssApiClientV1_V1_ByNodeid_VisitsDailySummary;


}

export class IbssApiClientV1_V1_ByNodeid implements IIbssApiClientV1_V1_ByNodeid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.bookingParties = new IbssApiClientV1_V1_ByNodeid_BookingParties(context);
        this.bookings = new IbssApiClientV1_V1_ByNodeid_Bookings(context);
        this.bookingsDailySummary = new IbssApiClientV1_V1_ByNodeid_BookingsDailySummary(context);
        this.buildingKpis = new IbssApiClientV1_V1_ByNodeid_BuildingKpis(context);
        this.buildings = new IbssApiClientV1_V1_ByNodeid_Buildings(context);
        this.connectors = new IbssApiClientV1_V1_ByNodeid_Connectors(context);
        this.costCodes = new IbssApiClientV1_V1_ByNodeid_CostCodes(context);
        this.environmentalSensors = new IbssApiClientV1_V1_ByNodeid_EnvironmentalSensors(context);
        this.environmentalZoneDailySummary = new IbssApiClientV1_V1_ByNodeid_EnvironmentalZoneDailySummary(context);
        this.environmentalZoneData = new IbssApiClientV1_V1_ByNodeid_EnvironmentalZoneData(context);
        this.environmentalZones = new IbssApiClientV1_V1_ByNodeid_EnvironmentalZones(context);
        this.environmentalZoneSummary = new IbssApiClientV1_V1_ByNodeid_EnvironmentalZoneSummary(context);
        this.equipment = new IbssApiClientV1_V1_ByNodeid_Equipment(context);
        this.floors = new IbssApiClientV1_V1_ByNodeid_Floors(context);
        this.languages = new IbssApiClientV1_V1_ByNodeid_Languages(context);
        this.lockers = new IbssApiClientV1_V1_ByNodeid_Lockers(context);
        this.nodes = new IbssApiClientV1_V1_ByNodeid_Nodes(context);
        this.notifications = new IbssApiClientV1_V1_ByNodeid_Notifications(context);
        this.parameters = new IbssApiClientV1_V1_ByNodeid_Parameters(context);
        this.regions = new IbssApiClientV1_V1_ByNodeid_Regions(context);
        this.resolversCategories = new IbssApiClientV1_V1_ByNodeid_ResolversCategories(context);
        this.resolversDailySummary = new IbssApiClientV1_V1_ByNodeid_ResolversDailySummary(context);
        this.signage = new IbssApiClientV1_V1_ByNodeid_Signage(context);
        this.spaceCateringMenu = new IbssApiClientV1_V1_ByNodeid_SpaceCateringMenu(context);
        this.spaces = new IbssApiClientV1_V1_ByNodeid_Spaces(context);
        this.spacesDailySummary = new IbssApiClientV1_V1_ByNodeid_SpacesDailySummary(context);
        this.spacesSummary = new IbssApiClientV1_V1_ByNodeid_SpacesSummary(context);
        this.spaceStates = new IbssApiClientV1_V1_ByNodeid_SpaceStates(context);
        this.spaceUtilisation = new IbssApiClientV1_V1_ByNodeid_SpaceUtilisation(context);
        this.spaceZones = new IbssApiClientV1_V1_ByNodeid_SpaceZones(context);
        this.supportedVersions = new IbssApiClientV1_V1_ByNodeid_SupportedVersions(context);
        this.taskCategories = new IbssApiClientV1_V1_ByNodeid_TaskCategories(context);
        this.tasks = new IbssApiClientV1_V1_ByNodeid_Tasks(context);
        this.tasksDailySummary = new IbssApiClientV1_V1_ByNodeid_TasksDailySummary(context);
        this.taskStates = new IbssApiClientV1_V1_ByNodeid_TaskStates(context);
        this.taskTypes = new IbssApiClientV1_V1_ByNodeid_TaskTypes(context);
        this.trackAndTrace = new IbssApiClientV1_V1_ByNodeid_TrackAndTrace(context);
        this.userNotifications = new IbssApiClientV1_V1_ByNodeid_UserNotifications(context);
        this.userPreferences = new IbssApiClientV1_V1_ByNodeid_UserPreferences(context);
        this.visits = new IbssApiClientV1_V1_ByNodeid_Visits(context);
        this.visitsDailySummary = new IbssApiClientV1_V1_ByNodeid_VisitsDailySummary(context);
    }

    public bookingParties: IbssApiClientV1_V1_ByNodeid_BookingParties;
    public bookings: IbssApiClientV1_V1_ByNodeid_Bookings;
    public bookingsDailySummary: IbssApiClientV1_V1_ByNodeid_BookingsDailySummary;
    public buildingKpis: IbssApiClientV1_V1_ByNodeid_BuildingKpis;
    public buildings: IbssApiClientV1_V1_ByNodeid_Buildings;
    public connectors: IbssApiClientV1_V1_ByNodeid_Connectors;
    public costCodes: IbssApiClientV1_V1_ByNodeid_CostCodes;
    public environmentalSensors: IbssApiClientV1_V1_ByNodeid_EnvironmentalSensors;
    public environmentalZoneDailySummary: IbssApiClientV1_V1_ByNodeid_EnvironmentalZoneDailySummary;
    public environmentalZoneData: IbssApiClientV1_V1_ByNodeid_EnvironmentalZoneData;
    public environmentalZones: IbssApiClientV1_V1_ByNodeid_EnvironmentalZones;
    public environmentalZoneSummary: IbssApiClientV1_V1_ByNodeid_EnvironmentalZoneSummary;
    public equipment: IbssApiClientV1_V1_ByNodeid_Equipment;
    public floors: IbssApiClientV1_V1_ByNodeid_Floors;
    public languages: IbssApiClientV1_V1_ByNodeid_Languages;
    public lockers: IbssApiClientV1_V1_ByNodeid_Lockers;
    public nodes: IbssApiClientV1_V1_ByNodeid_Nodes;
    public notifications: IbssApiClientV1_V1_ByNodeid_Notifications;
    public parameters: IbssApiClientV1_V1_ByNodeid_Parameters;
    public regions: IbssApiClientV1_V1_ByNodeid_Regions;
    public resolversCategories: IbssApiClientV1_V1_ByNodeid_ResolversCategories;
    public resolversDailySummary: IbssApiClientV1_V1_ByNodeid_ResolversDailySummary;
    public signage: IbssApiClientV1_V1_ByNodeid_Signage;
    public spaceCateringMenu: IbssApiClientV1_V1_ByNodeid_SpaceCateringMenu;
    public spaces: IbssApiClientV1_V1_ByNodeid_Spaces;
    public spacesDailySummary: IbssApiClientV1_V1_ByNodeid_SpacesDailySummary;
    public spacesSummary: IbssApiClientV1_V1_ByNodeid_SpacesSummary;
    public spaceStates: IbssApiClientV1_V1_ByNodeid_SpaceStates;
    public spaceUtilisation: IbssApiClientV1_V1_ByNodeid_SpaceUtilisation;
    public spaceZones: IbssApiClientV1_V1_ByNodeid_SpaceZones;
    public supportedVersions: IbssApiClientV1_V1_ByNodeid_SupportedVersions;
    public taskCategories: IbssApiClientV1_V1_ByNodeid_TaskCategories;
    public tasks: IbssApiClientV1_V1_ByNodeid_Tasks;
    public tasksDailySummary: IbssApiClientV1_V1_ByNodeid_TasksDailySummary;
    public taskStates: IbssApiClientV1_V1_ByNodeid_TaskStates;
    public taskTypes: IbssApiClientV1_V1_ByNodeid_TaskTypes;
    public trackAndTrace: IbssApiClientV1_V1_ByNodeid_TrackAndTrace;
    public userNotifications: IbssApiClientV1_V1_ByNodeid_UserNotifications;
    public userPreferences: IbssApiClientV1_V1_ByNodeid_UserPreferences;
    public visits: IbssApiClientV1_V1_ByNodeid_Visits;
    public visitsDailySummary: IbssApiClientV1_V1_ByNodeid_VisitsDailySummary;


}

export interface IIbssApiClientV1_V1_ByNodeid_BookingParties
{
    byRecordid: IIbssApiClientV1_V1_ByNodeid_BookingParties_ByRecordid;
    byBookingid: IIbssApiClientV1_V1_ByNodeid_BookingParties_ByBookingid;

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, schema?: boolean, body: IBookingPartyPostModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_BookingParties implements IIbssApiClientV1_V1_ByNodeid_BookingParties
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byRecordid = new IbssApiClientV1_V1_ByNodeid_BookingParties_ByRecordid(context);
        this.byBookingid = new IbssApiClientV1_V1_ByNodeid_BookingParties_ByBookingid(context);
    }

    public byRecordid: IbssApiClientV1_V1_ByNodeid_BookingParties_ByRecordid;
    public byBookingid: IbssApiClientV1_V1_ByNodeid_BookingParties_ByBookingid;


    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/BookingParties?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, schema?: boolean, body: IBookingPartyPostModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v1/${options.nodeId}/BookingParties?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_BookingParties_ByRecordid
{

    delete<TResponse>(options: { nodeId: number, recordid: string, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, recordid: string, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_BookingParties_ByRecordid implements IIbssApiClientV1_V1_ByNodeid_BookingParties_ByRecordid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, recordid: string, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v1/${options.nodeId}/BookingParties/${options.recordid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, recordid: string, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/BookingParties/${options.recordid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_BookingParties_ByBookingid
{

    put<TResponse>(options: { nodeId: number, bookingid: string, schema?: boolean, body: IBookingPartyPutModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_BookingParties_ByBookingid implements IIbssApiClientV1_V1_ByNodeid_BookingParties_ByBookingid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, bookingid: string, schema?: boolean, body: IBookingPartyPutModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/BookingParties/${options.bookingid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Bookings
{
    byBookingid: IIbssApiClientV1_V1_ByNodeid_Bookings_ByBookingid;
    userBookings: IIbssApiClientV1_V1_ByNodeid_Bookings_UserBookings;
    spaces: IIbssApiClientV1_V1_ByNodeid_Bookings_Spaces;
    checkedin: IIbssApiClientV1_V1_ByNodeid_Bookings_Checkedin;
    today: IIbssApiClientV1_V1_ByNodeid_Bookings_Today;
    download: IIbssApiClientV1_V1_ByNodeid_Bookings_Download;
    byBookingId: IIbssApiClientV1_V1_ByNodeid_Bookings_ByBookingId;
    search: IIbssApiClientV1_V1_ByNodeid_Bookings_Search;
    import: IIbssApiClientV1_V1_ByNodeid_Bookings_Import;

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, orderBy?: string, clientId?: Client, bookingStart?: string, bookingEnd?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: ISpaceBookRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Bookings implements IIbssApiClientV1_V1_ByNodeid_Bookings
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byBookingid = new IbssApiClientV1_V1_ByNodeid_Bookings_ByBookingid(context);
        this.userBookings = new IbssApiClientV1_V1_ByNodeid_Bookings_UserBookings(context);
        this.spaces = new IbssApiClientV1_V1_ByNodeid_Bookings_Spaces(context);
        this.checkedin = new IbssApiClientV1_V1_ByNodeid_Bookings_Checkedin(context);
        this.today = new IbssApiClientV1_V1_ByNodeid_Bookings_Today(context);
        this.download = new IbssApiClientV1_V1_ByNodeid_Bookings_Download(context);
        this.byBookingId = new IbssApiClientV1_V1_ByNodeid_Bookings_ByBookingId(context);
        this.search = new IbssApiClientV1_V1_ByNodeid_Bookings_Search(context);
        this.import = new IbssApiClientV1_V1_ByNodeid_Bookings_Import(context);
    }

    public byBookingid: IbssApiClientV1_V1_ByNodeid_Bookings_ByBookingid;
    public userBookings: IbssApiClientV1_V1_ByNodeid_Bookings_UserBookings;
    public spaces: IbssApiClientV1_V1_ByNodeid_Bookings_Spaces;
    public checkedin: IbssApiClientV1_V1_ByNodeid_Bookings_Checkedin;
    public today: IbssApiClientV1_V1_ByNodeid_Bookings_Today;
    public download: IbssApiClientV1_V1_ByNodeid_Bookings_Download;
    public byBookingId: IbssApiClientV1_V1_ByNodeid_Bookings_ByBookingId;
    public search: IbssApiClientV1_V1_ByNodeid_Bookings_Search;
    public import: IbssApiClientV1_V1_ByNodeid_Bookings_Import;


    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, orderBy?: string, clientId?: Client, bookingStart?: string, bookingEnd?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}
            if (options.clientId) { queryParts.push(`clientId=${encodeURIComponent(options.clientId)}`);}
            if (options.bookingStart) { queryParts.push(`bookingStart=${encodeURIComponent(options.bookingStart)}`);}
            if (options.bookingEnd) { queryParts.push(`bookingEnd=${encodeURIComponent(options.bookingEnd)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Bookings?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: ISpaceBookRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v1/${options.nodeId}/Bookings?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Bookings_ByBookingid
{

    delete<TResponse>(options: { nodeId: number, bookingid: string, disableExtUpdate?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, clientId?: Client, bookingid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Bookings_ByBookingid implements IIbssApiClientV1_V1_ByNodeid_Bookings_ByBookingid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, bookingid: string, disableExtUpdate?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.disableExtUpdate) { queryParts.push(`disableExtUpdate=${encodeURIComponent(options.disableExtUpdate)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v1/${options.nodeId}/Bookings/${options.bookingid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, clientId?: Client, bookingid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.clientId) { queryParts.push(`clientId=${encodeURIComponent(options.clientId)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Bookings/${options.bookingid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Bookings_UserBookings
{

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Bookings_UserBookings implements IIbssApiClientV1_V1_ByNodeid_Bookings_UserBookings
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Bookings/user-bookings?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Bookings_Spaces
{

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Bookings_Spaces implements IIbssApiClientV1_V1_ByNodeid_Bookings_Spaces
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Bookings/spaces?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Bookings_Checkedin
{

    get<TResponse>(options: { nodeId: number, clientId?: Client, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Bookings_Checkedin implements IIbssApiClientV1_V1_ByNodeid_Bookings_Checkedin
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, clientId?: Client, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.clientId) { queryParts.push(`clientId=${encodeURIComponent(options.clientId)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Bookings/checkedin?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Bookings_Today
{

    get<TResponse>(options: { nodeId: number, top?: number, clientId?: Client, n?: number, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Bookings_Today implements IIbssApiClientV1_V1_ByNodeid_Bookings_Today
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, top?: number, clientId?: Client, n?: number, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.clientId) { queryParts.push(`clientId=${encodeURIComponent(options.clientId)}`);}
            if (options.n) { queryParts.push(`n=${encodeURIComponent(options.n)}`);}
            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Bookings/today?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Bookings_Download
{

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Bookings_Download implements IIbssApiClientV1_V1_ByNodeid_Bookings_Download
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Bookings/download?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Bookings_ByBookingId
{
    rawdata: IIbssApiClientV1_V1_ByNodeid_Bookings_ByBookingId_Rawdata;

    put<TResponse>(options: { nodeId: number, bookingId: string, body: IUpdateBookingModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Bookings_ByBookingId implements IIbssApiClientV1_V1_ByNodeid_Bookings_ByBookingId
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.rawdata = new IbssApiClientV1_V1_ByNodeid_Bookings_ByBookingId_Rawdata(context);
    }

    public rawdata: IbssApiClientV1_V1_ByNodeid_Bookings_ByBookingId_Rawdata;


    public async put<TResponse>(options: { nodeId: number, bookingId: string, body: IUpdateBookingModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/Bookings/${options.bookingId}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Bookings_ByBookingId_Rawdata
{
    byDate: IIbssApiClientV1_V1_ByNodeid_Bookings_ByBookingId_Rawdata_ByDate;


}

export class IbssApiClientV1_V1_ByNodeid_Bookings_ByBookingId_Rawdata implements IIbssApiClientV1_V1_ByNodeid_Bookings_ByBookingId_Rawdata
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byDate = new IbssApiClientV1_V1_ByNodeid_Bookings_ByBookingId_Rawdata_ByDate(context);
    }

    public byDate: IbssApiClientV1_V1_ByNodeid_Bookings_ByBookingId_Rawdata_ByDate;


}

export interface IIbssApiClientV1_V1_ByNodeid_Bookings_ByBookingId_Rawdata_ByDate
{

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, bookingId: string, date: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Bookings_ByBookingId_Rawdata_ByDate implements IIbssApiClientV1_V1_ByNodeid_Bookings_ByBookingId_Rawdata_ByDate
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, bookingId: string, date: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Bookings/${options.bookingId}/rawdata/${options.date}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Bookings_Search
{

    post<TResponse>(options: { nodeId: number, select: new() => ODataSelect, top?: number, orderBy?: string, showDebugStats?: boolean, body: IBookingsSearchModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Bookings_Search implements IIbssApiClientV1_V1_ByNodeid_Bookings_Search
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { nodeId: number, select: new() => ODataSelect, top?: number, orderBy?: string, showDebugStats?: boolean, body: IBookingsSearchModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.orderBy) { queryParts.push(`orderBy=${encodeURIComponent(options.orderBy)}`);}
            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v1/${options.nodeId}/Bookings/search?${query}`, options.body, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Bookings_Import
{

    post<TResponse>(options: { nodeId: number, body: any, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Bookings_Import implements IIbssApiClientV1_V1_ByNodeid_Bookings_Import
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { nodeId: number, body: any, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v1/${options.nodeId}/Bookings/import?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_BookingsDailySummary
{
    byStartDate: IIbssApiClientV1_V1_ByNodeid_BookingsDailySummary_ByStartDate;
    recalculate: IIbssApiClientV1_V1_ByNodeid_BookingsDailySummary_Recalculate;


}

export class IbssApiClientV1_V1_ByNodeid_BookingsDailySummary implements IIbssApiClientV1_V1_ByNodeid_BookingsDailySummary
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byStartDate = new IbssApiClientV1_V1_ByNodeid_BookingsDailySummary_ByStartDate(context);
        this.recalculate = new IbssApiClientV1_V1_ByNodeid_BookingsDailySummary_Recalculate(context);
    }

    public byStartDate: IbssApiClientV1_V1_ByNodeid_BookingsDailySummary_ByStartDate;
    public recalculate: IbssApiClientV1_V1_ByNodeid_BookingsDailySummary_Recalculate;


}

export interface IIbssApiClientV1_V1_ByNodeid_BookingsDailySummary_ByStartDate
{
    byEndDate: IIbssApiClientV1_V1_ByNodeid_BookingsDailySummary_ByStartDate_ByEndDate;


}

export class IbssApiClientV1_V1_ByNodeid_BookingsDailySummary_ByStartDate implements IIbssApiClientV1_V1_ByNodeid_BookingsDailySummary_ByStartDate
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byEndDate = new IbssApiClientV1_V1_ByNodeid_BookingsDailySummary_ByStartDate_ByEndDate(context);
    }

    public byEndDate: IbssApiClientV1_V1_ByNodeid_BookingsDailySummary_ByStartDate_ByEndDate;


}

export interface IIbssApiClientV1_V1_ByNodeid_BookingsDailySummary_ByStartDate_ByEndDate
{
    bookingsSummaryData: IIbssApiClientV1_V1_ByNodeid_BookingsDailySummary_ByStartDate_ByEndDate_BookingsSummaryData;


}

export class IbssApiClientV1_V1_ByNodeid_BookingsDailySummary_ByStartDate_ByEndDate implements IIbssApiClientV1_V1_ByNodeid_BookingsDailySummary_ByStartDate_ByEndDate
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.bookingsSummaryData = new IbssApiClientV1_V1_ByNodeid_BookingsDailySummary_ByStartDate_ByEndDate_BookingsSummaryData(context);
    }

    public bookingsSummaryData: IbssApiClientV1_V1_ByNodeid_BookingsDailySummary_ByStartDate_ByEndDate_BookingsSummaryData;


}

export interface IIbssApiClientV1_V1_ByNodeid_BookingsDailySummary_ByStartDate_ByEndDate_BookingsSummaryData
{

    get<TResponse>(options: { nodeId: number, recursive?: boolean, startDate: string, endDate: string, spaceId?: string, isUtc?: boolean, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_BookingsDailySummary_ByStartDate_ByEndDate_BookingsSummaryData implements IIbssApiClientV1_V1_ByNodeid_BookingsDailySummary_ByStartDate_ByEndDate_BookingsSummaryData
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, startDate: string, endDate: string, spaceId?: string, isUtc?: boolean, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            if (options.spaceId) { queryParts.push(`spaceId=${encodeURIComponent(options.spaceId)}`);}
            if (options.isUtc) { queryParts.push(`isUtc=${encodeURIComponent(options.isUtc)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/BookingsDailySummary/${options.startDate}/${options.endDate}/BookingsSummaryData?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_BookingsDailySummary_Recalculate
{

    get<TResponse>(options: { nodeId: number, startDate?: string, endDate?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_BookingsDailySummary_Recalculate implements IIbssApiClientV1_V1_ByNodeid_BookingsDailySummary_Recalculate
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, startDate?: string, endDate?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.startDate) { queryParts.push(`startDate=${encodeURIComponent(options.startDate)}`);}
            if (options.endDate) { queryParts.push(`endDate=${encodeURIComponent(options.endDate)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/BookingsDailySummary/Recalculate?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_BuildingKpis
{
    byBuildingKpiid: IIbssApiClientV1_V1_ByNodeid_BuildingKpis_ByBuildingKpiid;
    byBuildingkpiid: IIbssApiClientV1_V1_ByNodeid_BuildingKpis_ByBuildingkpiid;
    refresh: IIbssApiClientV1_V1_ByNodeid_BuildingKpis_Refresh;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: IBuildingKPICreate, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_BuildingKpis implements IIbssApiClientV1_V1_ByNodeid_BuildingKpis
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byBuildingKpiid = new IbssApiClientV1_V1_ByNodeid_BuildingKpis_ByBuildingKpiid(context);
        this.byBuildingkpiid = new IbssApiClientV1_V1_ByNodeid_BuildingKpis_ByBuildingkpiid(context);
        this.refresh = new IbssApiClientV1_V1_ByNodeid_BuildingKpis_Refresh(context);
    }

    public byBuildingKpiid: IbssApiClientV1_V1_ByNodeid_BuildingKpis_ByBuildingKpiid;
    public byBuildingkpiid: IbssApiClientV1_V1_ByNodeid_BuildingKpis_ByBuildingkpiid;
    public refresh: IbssApiClientV1_V1_ByNodeid_BuildingKpis_Refresh;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/BuildingKPIs?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: IBuildingKPICreate, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v1/${options.nodeId}/BuildingKPIs?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_BuildingKpis_ByBuildingKpiid
{

    delete<TResponse>(options: { nodeId: number, buildingKpiid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, buildingKpiid: number, body: IBuildingKPIUpdate, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_BuildingKpis_ByBuildingKpiid implements IIbssApiClientV1_V1_ByNodeid_BuildingKpis_ByBuildingKpiid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, buildingKpiid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v1/${options.nodeId}/BuildingKPIs/${options.buildingKpiid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, buildingKpiid: number, body: IBuildingKPIUpdate, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/BuildingKPIs/${options.buildingKpiid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_BuildingKpis_ByBuildingkpiid
{
    refresh: IIbssApiClientV1_V1_ByNodeid_BuildingKpis_ByBuildingkpiid_Refresh;

    get<TResponse>(options: { nodeId: number, buildingkpiid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_BuildingKpis_ByBuildingkpiid implements IIbssApiClientV1_V1_ByNodeid_BuildingKpis_ByBuildingkpiid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.refresh = new IbssApiClientV1_V1_ByNodeid_BuildingKpis_ByBuildingkpiid_Refresh(context);
    }

    public refresh: IbssApiClientV1_V1_ByNodeid_BuildingKpis_ByBuildingkpiid_Refresh;


    public async get<TResponse>(options: { nodeId: number, buildingkpiid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/BuildingKPIs/${options.buildingkpiid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_BuildingKpis_Refresh
{

    get<TResponse>(options: { nodeId: number, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_BuildingKpis_Refresh implements IIbssApiClientV1_V1_ByNodeid_BuildingKpis_Refresh
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/BuildingKPIs/refresh?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_BuildingKpis_ByBuildingkpiid_Refresh
{

    get<TResponse>(options: { nodeId: number, buildingkpiid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_BuildingKpis_ByBuildingkpiid_Refresh implements IIbssApiClientV1_V1_ByNodeid_BuildingKpis_ByBuildingkpiid_Refresh
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, buildingkpiid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/BuildingKPIs/${options.buildingkpiid}/refresh?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Buildings
{
    byBuildingid: IIbssApiClientV1_V1_ByNodeid_Buildings_ByBuildingid;

    get<TResponse>(options: { nodeId: number, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Buildings implements IIbssApiClientV1_V1_ByNodeid_Buildings
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byBuildingid = new IbssApiClientV1_V1_ByNodeid_Buildings_ByBuildingid(context);
    }

    public byBuildingid: IbssApiClientV1_V1_ByNodeid_Buildings_ByBuildingid;


    public async get<TResponse>(options: { nodeId: number, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Buildings?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Buildings_ByBuildingid
{
    environmental: IIbssApiClientV1_V1_ByNodeid_Buildings_ByBuildingid_Environmental;

    get<TResponse>(options: { nodeId: number, buildingid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Buildings_ByBuildingid implements IIbssApiClientV1_V1_ByNodeid_Buildings_ByBuildingid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.environmental = new IbssApiClientV1_V1_ByNodeid_Buildings_ByBuildingid_Environmental(context);
    }

    public environmental: IbssApiClientV1_V1_ByNodeid_Buildings_ByBuildingid_Environmental;


    public async get<TResponse>(options: { nodeId: number, buildingid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Buildings/${options.buildingid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Buildings_ByBuildingid_Environmental
{

    get<TResponse>(options: { nodeId: number, top?: number, buildingid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Buildings_ByBuildingid_Environmental implements IIbssApiClientV1_V1_ByNodeid_Buildings_ByBuildingid_Environmental
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, top?: number, buildingid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Buildings/${options.buildingid}/environmental?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Connectors
{
    byConnectorid: IIbssApiClientV1_V1_ByNodeid_Connectors_ByConnectorid;

    get<TResponse>(options: { nodeId: number, filter?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Connectors implements IIbssApiClientV1_V1_ByNodeid_Connectors
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byConnectorid = new IbssApiClientV1_V1_ByNodeid_Connectors_ByConnectorid(context);
    }

    public byConnectorid: IbssApiClientV1_V1_ByNodeid_Connectors_ByConnectorid;


    public async get<TResponse>(options: { nodeId: number, filter?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Connectors?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Connectors_ByConnectorid
{

    get<TResponse>(options: { nodeId: number, connectorid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Connectors_ByConnectorid implements IIbssApiClientV1_V1_ByNodeid_Connectors_ByConnectorid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, connectorid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Connectors/${options.connectorid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_CostCodes
{
    byCostcodeid: IIbssApiClientV1_V1_ByNodeid_CostCodes_ByCostcodeid;

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: ICostCodePostModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_CostCodes implements IIbssApiClientV1_V1_ByNodeid_CostCodes
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byCostcodeid = new IbssApiClientV1_V1_ByNodeid_CostCodes_ByCostcodeid(context);
    }

    public byCostcodeid: IbssApiClientV1_V1_ByNodeid_CostCodes_ByCostcodeid;


    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/CostCodes?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: ICostCodePostModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v1/${options.nodeId}/CostCodes?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_CostCodes_ByCostcodeid
{

    delete<TResponse>(options: { nodeId: number, costcodeid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, costcodeid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, costcodeid: string, body: ICostCodeUpdateModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_CostCodes_ByCostcodeid implements IIbssApiClientV1_V1_ByNodeid_CostCodes_ByCostcodeid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, costcodeid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v1/${options.nodeId}/CostCodes/${options.costcodeid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, costcodeid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/CostCodes/${options.costcodeid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, costcodeid: string, body: ICostCodeUpdateModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/CostCodes/${options.costcodeid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_Delegates
{
    myDelegates: IIbssApiClientV1_V1_Delegates_MyDelegates;
    myPrimaries: IIbssApiClientV1_V1_Delegates_MyPrimaries;


}

export class IbssApiClientV1_V1_Delegates implements IIbssApiClientV1_V1_Delegates
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.myDelegates = new IbssApiClientV1_V1_Delegates_MyDelegates(context);
        this.myPrimaries = new IbssApiClientV1_V1_Delegates_MyPrimaries(context);
    }

    public myDelegates: IbssApiClientV1_V1_Delegates_MyDelegates;
    public myPrimaries: IbssApiClientV1_V1_Delegates_MyPrimaries;


}

export interface IIbssApiClientV1_V1_Delegates_MyDelegates
{

    get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_Delegates_MyDelegates implements IIbssApiClientV1_V1_Delegates_MyDelegates
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            queryParts.push(`$expand=${encodeURIComponent(new options.select().toExpand())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/delegates/my-delegates?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_Delegates_MyPrimaries
{

    get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_Delegates_MyPrimaries implements IIbssApiClientV1_V1_Delegates_MyPrimaries
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            queryParts.push(`$expand=${encodeURIComponent(new options.select().toExpand())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/delegates/my-primaries?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_Devices
{
    byDeviceId: IIbssApiClientV1_V1_Devices_ByDeviceId;
    byNodeId: IIbssApiClientV1_V1_Devices_ByNodeId;
    byDeviceType: IIbssApiClientV1_V1_Devices_ByDeviceType;
    status: IIbssApiClientV1_V1_Devices_Status;

    get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, orderBy?: string, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId?: number, body: IPostDevice, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_Devices implements IIbssApiClientV1_V1_Devices
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byDeviceId = new IbssApiClientV1_V1_Devices_ByDeviceId(context);
        this.byNodeId = new IbssApiClientV1_V1_Devices_ByNodeId(context);
        this.byDeviceType = new IbssApiClientV1_V1_Devices_ByDeviceType(context);
        this.status = new IbssApiClientV1_V1_Devices_Status(context);
    }

    public byDeviceId: IbssApiClientV1_V1_Devices_ByDeviceId;
    public byNodeId: IbssApiClientV1_V1_Devices_ByNodeId;
    public byDeviceType: IbssApiClientV1_V1_Devices_ByDeviceType;
    public status: IbssApiClientV1_V1_Devices_Status;


    public async get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, orderBy?: string, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/Devices?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId?: number, body: IPostDevice, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.nodeId) { queryParts.push(`nodeid=${encodeURIComponent(options.nodeId)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v1/Devices?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_Devices_ByDeviceId
{
    sendCommand: IIbssApiClientV1_V1_Devices_ByDeviceId_SendCommand;
    update: IIbssApiClientV1_V1_Devices_ByDeviceId_Update;
    status: IIbssApiClientV1_V1_Devices_ByDeviceId_Status;

    delete<TResponse>(options: { deviceId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { deviceId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { deviceId: number, body: IUpdateModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_Devices_ByDeviceId implements IIbssApiClientV1_V1_Devices_ByDeviceId
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.sendCommand = new IbssApiClientV1_V1_Devices_ByDeviceId_SendCommand(context);
        this.update = new IbssApiClientV1_V1_Devices_ByDeviceId_Update(context);
        this.status = new IbssApiClientV1_V1_Devices_ByDeviceId_Status(context);
    }

    public sendCommand: IbssApiClientV1_V1_Devices_ByDeviceId_SendCommand;
    public update: IbssApiClientV1_V1_Devices_ByDeviceId_Update;
    public status: IbssApiClientV1_V1_Devices_ByDeviceId_Status;


    public async delete<TResponse>(options: { deviceId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v1/Devices/${options.deviceId}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { deviceId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/Devices/${options.deviceId}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { deviceId: number, body: IUpdateModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/Devices/${options.deviceId}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_Devices_ByNodeId
{
    nodedevices: IIbssApiClientV1_V1_Devices_ByNodeId_Nodedevices;


}

export class IbssApiClientV1_V1_Devices_ByNodeId implements IIbssApiClientV1_V1_Devices_ByNodeId
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.nodedevices = new IbssApiClientV1_V1_Devices_ByNodeId_Nodedevices(context);
    }

    public nodedevices: IbssApiClientV1_V1_Devices_ByNodeId_Nodedevices;


}

export interface IIbssApiClientV1_V1_Devices_ByNodeId_Nodedevices
{

    get<TResponse>(options: { nodeId: number, recursive?: boolean, top?: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_Devices_ByNodeId_Nodedevices implements IIbssApiClientV1_V1_Devices_ByNodeId_Nodedevices
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, top?: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/Devices/${options.nodeId}/nodedevices?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_Devices_ByDeviceType
{
    byDeviceCode: IIbssApiClientV1_V1_Devices_ByDeviceType_ByDeviceCode;


}

export class IbssApiClientV1_V1_Devices_ByDeviceType implements IIbssApiClientV1_V1_Devices_ByDeviceType
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byDeviceCode = new IbssApiClientV1_V1_Devices_ByDeviceType_ByDeviceCode(context);
    }

    public byDeviceCode: IbssApiClientV1_V1_Devices_ByDeviceType_ByDeviceCode;


}

export interface IIbssApiClientV1_V1_Devices_ByDeviceType_ByDeviceCode
{
    deviceInfo: IIbssApiClientV1_V1_Devices_ByDeviceType_ByDeviceCode_DeviceInfo;


}

export class IbssApiClientV1_V1_Devices_ByDeviceType_ByDeviceCode implements IIbssApiClientV1_V1_Devices_ByDeviceType_ByDeviceCode
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.deviceInfo = new IbssApiClientV1_V1_Devices_ByDeviceType_ByDeviceCode_DeviceInfo(context);
    }

    public deviceInfo: IbssApiClientV1_V1_Devices_ByDeviceType_ByDeviceCode_DeviceInfo;


}

export interface IIbssApiClientV1_V1_Devices_ByDeviceType_ByDeviceCode_DeviceInfo
{

    get<TResponse>(options: { top?: number, deviceType: number, deviceCode: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_Devices_ByDeviceType_ByDeviceCode_DeviceInfo implements IIbssApiClientV1_V1_Devices_ByDeviceType_ByDeviceCode_DeviceInfo
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { top?: number, deviceType: number, deviceCode: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/Devices/${options.deviceType}/${options.deviceCode}/deviceInfo?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_Devices_Status
{

    get<TResponse>(options: { select: new() => ODataSelect, filter?: string, schema?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_Devices_Status implements IIbssApiClientV1_V1_Devices_Status
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { select: new() => ODataSelect, filter?: string, schema?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}
            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/Devices/Status?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_Devices_ByDeviceId_SendCommand
{

    post<TResponse>(options: { deviceId: number, body: ICommandRequestEntity, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_Devices_ByDeviceId_SendCommand implements IIbssApiClientV1_V1_Devices_ByDeviceId_SendCommand
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { deviceId: number, body: ICommandRequestEntity, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v1/Devices/${options.deviceId}/SendCommand?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_Devices_ByDeviceId_Update
{

    post<TResponse>(options: { deviceId: number, body: IDeviceStatusUpdate[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_Devices_ByDeviceId_Update implements IIbssApiClientV1_V1_Devices_ByDeviceId_Update
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { deviceId: number, body: IDeviceStatusUpdate[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v1/Devices/${options.deviceId}/Update?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_Devices_ByDeviceId_Status
{

    put<TResponse>(options: { deviceId: number, body: IDeviceStatusUpdate[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_Devices_ByDeviceId_Status implements IIbssApiClientV1_V1_Devices_ByDeviceId_Status
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { deviceId: number, body: IDeviceStatusUpdate[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/Devices/${options.deviceId}/Status?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_EnvironmentalSensors
{
    byEnvSensorId: IIbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId;

    get<TResponse>(options: { nodeId: number, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: ICreateEnvSensor, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_EnvironmentalSensors implements IIbssApiClientV1_V1_ByNodeid_EnvironmentalSensors
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byEnvSensorId = new IbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId(context);
    }

    public byEnvSensorId: IbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId;


    public async get<TResponse>(options: { nodeId: number, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/EnvironmentalSensors?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: ICreateEnvSensor, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v1/${options.nodeId}/EnvironmentalSensors?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId
{
    update: IIbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId_Update;
    assignZone: IIbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId_AssignZone;
    unassignZone: IIbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId_UnassignZone;
    enable: IIbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId_Enable;
    disable: IIbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId_Disable;

    delete<TResponse>(options: { nodeId: number, envSensorId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, envSensorId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId implements IIbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.update = new IbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId_Update(context);
        this.assignZone = new IbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId_AssignZone(context);
        this.unassignZone = new IbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId_UnassignZone(context);
        this.enable = new IbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId_Enable(context);
        this.disable = new IbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId_Disable(context);
    }

    public update: IbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId_Update;
    public assignZone: IbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId_AssignZone;
    public unassignZone: IbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId_UnassignZone;
    public enable: IbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId_Enable;
    public disable: IbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId_Disable;


    public async delete<TResponse>(options: { nodeId: number, envSensorId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v1/${options.nodeId}/EnvironmentalSensors/${options.envSensorId}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, envSensorId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/EnvironmentalSensors/${options.envSensorId}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId_Update
{

    put<TResponse>(options: { nodeId: number, envSensorId: string, body: IEnvSensorUpdateModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId_Update implements IIbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId_Update
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, envSensorId: string, body: IEnvSensorUpdateModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/EnvironmentalSensors/${options.envSensorId}/update?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId_AssignZone
{
    byEnvZoneId: IIbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId_AssignZone_ByEnvZoneId;


}

export class IbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId_AssignZone implements IIbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId_AssignZone
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byEnvZoneId = new IbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId_AssignZone_ByEnvZoneId(context);
    }

    public byEnvZoneId: IbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId_AssignZone_ByEnvZoneId;


}

export interface IIbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId_AssignZone_ByEnvZoneId
{

    put<TResponse>(options: { nodeId: number, envSensorId: string, envZoneId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId_AssignZone_ByEnvZoneId implements IIbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId_AssignZone_ByEnvZoneId
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, envSensorId: string, envZoneId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/EnvironmentalSensors/${options.envSensorId}/assign-zone/${options.envZoneId}?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId_UnassignZone
{

    put<TResponse>(options: { nodeId: number, envSensorId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId_UnassignZone implements IIbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId_UnassignZone
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, envSensorId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/EnvironmentalSensors/${options.envSensorId}/unassign-zone?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId_Enable
{

    put<TResponse>(options: { nodeId: number, envSensorId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId_Enable implements IIbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId_Enable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, envSensorId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/EnvironmentalSensors/${options.envSensorId}/enable?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId_Disable
{

    put<TResponse>(options: { nodeId: number, envSensorId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId_Disable implements IIbssApiClientV1_V1_ByNodeid_EnvironmentalSensors_ByEnvSensorId_Disable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, envSensorId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/EnvironmentalSensors/${options.envSensorId}/disable?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_EnvironmentalZoneDailySummary
{
    recalculate: IIbssApiClientV1_V1_ByNodeid_EnvironmentalZoneDailySummary_Recalculate;

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, startDate?: string, endDate?: string, isUtc?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_EnvironmentalZoneDailySummary implements IIbssApiClientV1_V1_ByNodeid_EnvironmentalZoneDailySummary
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.recalculate = new IbssApiClientV1_V1_ByNodeid_EnvironmentalZoneDailySummary_Recalculate(context);
    }

    public recalculate: IbssApiClientV1_V1_ByNodeid_EnvironmentalZoneDailySummary_Recalculate;


    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, startDate?: string, endDate?: string, isUtc?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.startDate) { queryParts.push(`startDate=${encodeURIComponent(options.startDate)}`);}
            if (options.endDate) { queryParts.push(`endDate=${encodeURIComponent(options.endDate)}`);}
            if (options.isUtc) { queryParts.push(`isUtc=${encodeURIComponent(options.isUtc)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/EnvironmentalZoneDailySummary?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_EnvironmentalZoneDailySummary_Recalculate
{

    get<TResponse>(options: { nodeId: number, startDate?: string, endDate?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_EnvironmentalZoneDailySummary_Recalculate implements IIbssApiClientV1_V1_ByNodeid_EnvironmentalZoneDailySummary_Recalculate
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, startDate?: string, endDate?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.startDate) { queryParts.push(`startDate=${encodeURIComponent(options.startDate)}`);}
            if (options.endDate) { queryParts.push(`endDate=${encodeURIComponent(options.endDate)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/EnvironmentalZoneDailySummary/Recalculate?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_EnvironmentalZoneData
{
    byEnvzoneid: IIbssApiClientV1_V1_ByNodeid_EnvironmentalZoneData_ByEnvzoneid;
    zonesData: IIbssApiClientV1_V1_ByNodeid_EnvironmentalZoneData_ZonesData;

    get<TResponse>(options: { nodeId: number, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_EnvironmentalZoneData implements IIbssApiClientV1_V1_ByNodeid_EnvironmentalZoneData
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byEnvzoneid = new IbssApiClientV1_V1_ByNodeid_EnvironmentalZoneData_ByEnvzoneid(context);
        this.zonesData = new IbssApiClientV1_V1_ByNodeid_EnvironmentalZoneData_ZonesData(context);
    }

    public byEnvzoneid: IbssApiClientV1_V1_ByNodeid_EnvironmentalZoneData_ByEnvzoneid;
    public zonesData: IbssApiClientV1_V1_ByNodeid_EnvironmentalZoneData_ZonesData;


    public async get<TResponse>(options: { nodeId: number, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/EnvironmentalZoneData?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_EnvironmentalZoneData_ByEnvzoneid
{

    get<TResponse>(options: { nodeId: number, envzoneid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_EnvironmentalZoneData_ByEnvzoneid implements IIbssApiClientV1_V1_ByNodeid_EnvironmentalZoneData_ByEnvzoneid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, envzoneid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/EnvironmentalZoneData/${options.envzoneid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_EnvironmentalZoneData_ZonesData
{

    get<TResponse>(options: { nodeId: number, envZoneIds?: number[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_EnvironmentalZoneData_ZonesData implements IIbssApiClientV1_V1_ByNodeid_EnvironmentalZoneData_ZonesData
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, envZoneIds?: number[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.envZoneIds) { options.envZoneIds.forEach(i => queryParts.push(`envZoneIds=${encodeURIComponent(i)}`));}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/EnvironmentalZoneData/ZonesData?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_EnvironmentalZones
{
    byEnvzoneid: IIbssApiClientV1_V1_ByNodeid_EnvironmentalZones_ByEnvzoneid;

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: ICreateEnvironmentalZone, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_EnvironmentalZones implements IIbssApiClientV1_V1_ByNodeid_EnvironmentalZones
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byEnvzoneid = new IbssApiClientV1_V1_ByNodeid_EnvironmentalZones_ByEnvzoneid(context);
    }

    public byEnvzoneid: IbssApiClientV1_V1_ByNodeid_EnvironmentalZones_ByEnvzoneid;


    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/EnvironmentalZones?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: ICreateEnvironmentalZone, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v1/${options.nodeId}/EnvironmentalZones?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_EnvironmentalZones_ByEnvzoneid
{
    byName: IIbssApiClientV1_V1_ByNodeid_EnvironmentalZones_ByEnvzoneid_ByName;
    enable: IIbssApiClientV1_V1_ByNodeid_EnvironmentalZones_ByEnvzoneid_Enable;
    disable: IIbssApiClientV1_V1_ByNodeid_EnvironmentalZones_ByEnvzoneid_Disable;

    delete<TResponse>(options: { nodeId: number, envzoneid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, envzoneid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, envzoneid: number, body: ICreateEnvironmentalZonePutRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_EnvironmentalZones_ByEnvzoneid implements IIbssApiClientV1_V1_ByNodeid_EnvironmentalZones_ByEnvzoneid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byName = new IbssApiClientV1_V1_ByNodeid_EnvironmentalZones_ByEnvzoneid_ByName(context);
        this.enable = new IbssApiClientV1_V1_ByNodeid_EnvironmentalZones_ByEnvzoneid_Enable(context);
        this.disable = new IbssApiClientV1_V1_ByNodeid_EnvironmentalZones_ByEnvzoneid_Disable(context);
    }

    public byName: IbssApiClientV1_V1_ByNodeid_EnvironmentalZones_ByEnvzoneid_ByName;
    public enable: IbssApiClientV1_V1_ByNodeid_EnvironmentalZones_ByEnvzoneid_Enable;
    public disable: IbssApiClientV1_V1_ByNodeid_EnvironmentalZones_ByEnvzoneid_Disable;


    public async delete<TResponse>(options: { nodeId: number, envzoneid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v1/${options.nodeId}/EnvironmentalZones/${options.envzoneid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, envzoneid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/EnvironmentalZones/${options.envzoneid}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, envzoneid: number, body: ICreateEnvironmentalZonePutRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/EnvironmentalZones/${options.envzoneid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_EnvironmentalZones_ByEnvzoneid_ByName
{

    put<TResponse>(options: { nodeId: number, envzoneid: number, name: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_EnvironmentalZones_ByEnvzoneid_ByName implements IIbssApiClientV1_V1_ByNodeid_EnvironmentalZones_ByEnvzoneid_ByName
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, envzoneid: number, name: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/EnvironmentalZones/${options.envzoneid}/${options.name}?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_EnvironmentalZones_ByEnvzoneid_Enable
{

    put<TResponse>(options: { nodeId: number, envzoneid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_EnvironmentalZones_ByEnvzoneid_Enable implements IIbssApiClientV1_V1_ByNodeid_EnvironmentalZones_ByEnvzoneid_Enable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, envzoneid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/EnvironmentalZones/${options.envzoneid}/enable?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_EnvironmentalZones_ByEnvzoneid_Disable
{

    put<TResponse>(options: { nodeId: number, envzoneid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_EnvironmentalZones_ByEnvzoneid_Disable implements IIbssApiClientV1_V1_ByNodeid_EnvironmentalZones_ByEnvzoneid_Disable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, envzoneid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/EnvironmentalZones/${options.envzoneid}/disable?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_EnvironmentalZoneSummary
{

    get<TResponse>(options: { nodeId: number, top?: number, startDate?: string, endDate?: string, isUtc?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_EnvironmentalZoneSummary implements IIbssApiClientV1_V1_ByNodeid_EnvironmentalZoneSummary
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, top?: number, startDate?: string, endDate?: string, isUtc?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.startDate) { queryParts.push(`startDate=${encodeURIComponent(options.startDate)}`);}
            if (options.endDate) { queryParts.push(`endDate=${encodeURIComponent(options.endDate)}`);}
            if (options.isUtc) { queryParts.push(`isUtc=${encodeURIComponent(options.isUtc)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/EnvironmentalZoneSummary?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Equipment
{
    byEquipid: IIbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid;
    definitions: IIbssApiClientV1_V1_ByNodeid_Equipment_Definitions;
    refresh: IIbssApiClientV1_V1_ByNodeid_Equipment_Refresh;
    search: IIbssApiClientV1_V1_ByNodeid_Equipment_Search;
    available: IIbssApiClientV1_V1_ByNodeid_Equipment_Available;

    get<TResponse>(options: { nodeId: number, top?: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, schema?: boolean, body: IEquipmentCreateVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Equipment implements IIbssApiClientV1_V1_ByNodeid_Equipment
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byEquipid = new IbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid(context);
        this.definitions = new IbssApiClientV1_V1_ByNodeid_Equipment_Definitions(context);
        this.refresh = new IbssApiClientV1_V1_ByNodeid_Equipment_Refresh(context);
        this.search = new IbssApiClientV1_V1_ByNodeid_Equipment_Search(context);
        this.available = new IbssApiClientV1_V1_ByNodeid_Equipment_Available(context);
    }

    public byEquipid: IbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid;
    public definitions: IbssApiClientV1_V1_ByNodeid_Equipment_Definitions;
    public refresh: IbssApiClientV1_V1_ByNodeid_Equipment_Refresh;
    public search: IbssApiClientV1_V1_ByNodeid_Equipment_Search;
    public available: IbssApiClientV1_V1_ByNodeid_Equipment_Available;


    public async get<TResponse>(options: { nodeId: number, top?: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Equipment?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, schema?: boolean, body: IEquipmentCreateVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v1/${options.nodeId}/Equipment?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid
{
    tasks: IIbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid_Tasks;
    definitions: IIbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid_Definitions;
    refresh: IIbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid_Refresh;
    bookings: IIbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid_Bookings;
    enable: IIbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid_Enable;
    disable: IIbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid_Disable;

    delete<TResponse>(options: { nodeId: number, equipid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, equipid: string, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid implements IIbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.tasks = new IbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid_Tasks(context);
        this.definitions = new IbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid_Definitions(context);
        this.refresh = new IbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid_Refresh(context);
        this.bookings = new IbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid_Bookings(context);
        this.enable = new IbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid_Enable(context);
        this.disable = new IbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid_Disable(context);
    }

    public tasks: IbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid_Tasks;
    public definitions: IbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid_Definitions;
    public refresh: IbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid_Refresh;
    public bookings: IbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid_Bookings;
    public enable: IbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid_Enable;
    public disable: IbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid_Disable;


    public async delete<TResponse>(options: { nodeId: number, equipid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v1/${options.nodeId}/Equipment/${options.equipid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, equipid: string, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Equipment/${options.equipid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid_Tasks
{

    get<TResponse>(options: { nodeId: number, top?: number, equipid: string, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid_Tasks implements IIbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid_Tasks
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, top?: number, equipid: string, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Equipment/${options.equipid}/tasks?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Equipment_Definitions
{

    get<TResponse>(options: { nodeId: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Equipment_Definitions implements IIbssApiClientV1_V1_ByNodeid_Equipment_Definitions
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Equipment/definitions?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid_Definitions
{

    get<TResponse>(options: { nodeId: number, equipid: string, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid_Definitions implements IIbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid_Definitions
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, equipid: string, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Equipment/${options.equipid}/definitions?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Equipment_Refresh
{

    get<TResponse>(options: { nodeId: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Equipment_Refresh implements IIbssApiClientV1_V1_ByNodeid_Equipment_Refresh
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Equipment/refresh?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid_Refresh
{

    get<TResponse>(options: { nodeId: number, equipid: string, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid_Refresh implements IIbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid_Refresh
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, equipid: string, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Equipment/${options.equipid}/refresh?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Equipment_Search
{

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Equipment_Search implements IIbssApiClientV1_V1_ByNodeid_Equipment_Search
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Equipment/search?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid_Bookings
{

    post<TResponse>(options: { nodeId: number, top?: number, equipid: string, schema?: boolean, body: IEquipmentBookingModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid_Bookings implements IIbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid_Bookings
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { nodeId: number, top?: number, equipid: string, schema?: boolean, body: IEquipmentBookingModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v1/${options.nodeId}/Equipment/${options.equipid}/bookings?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Equipment_Available
{

    post<TResponse>(options: { nodeId: number, schema?: boolean, body: IAvailableEquipment, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Equipment_Available implements IIbssApiClientV1_V1_ByNodeid_Equipment_Available
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { nodeId: number, schema?: boolean, body: IAvailableEquipment, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v1/${options.nodeId}/Equipment/available?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid_Enable
{

    put<TResponse>(options: { nodeId: number, equipid: string, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid_Enable implements IIbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid_Enable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, equipid: string, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/Equipment/${options.equipid}/enable?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid_Disable
{

    put<TResponse>(options: { nodeId: number, equipid: string, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid_Disable implements IIbssApiClientV1_V1_ByNodeid_Equipment_ByEquipid_Disable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, equipid: string, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/Equipment/${options.equipid}/disable?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Floors
{
    availability: IIbssApiClientV1_V1_ByNodeid_Floors_Availability;
    byFloorid: IIbssApiClientV1_V1_ByNodeid_Floors_ByFloorid;
    environmental: IIbssApiClientV1_V1_ByNodeid_Floors_Environmental;
    availabilityAndEnvironmental: IIbssApiClientV1_V1_ByNodeid_Floors_AvailabilityAndEnvironmental;

    get<TResponse>(options: { nodeId: number, top?: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Floors implements IIbssApiClientV1_V1_ByNodeid_Floors
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.availability = new IbssApiClientV1_V1_ByNodeid_Floors_Availability(context);
        this.byFloorid = new IbssApiClientV1_V1_ByNodeid_Floors_ByFloorid(context);
        this.environmental = new IbssApiClientV1_V1_ByNodeid_Floors_Environmental(context);
        this.availabilityAndEnvironmental = new IbssApiClientV1_V1_ByNodeid_Floors_AvailabilityAndEnvironmental(context);
    }

    public availability: IbssApiClientV1_V1_ByNodeid_Floors_Availability;
    public byFloorid: IbssApiClientV1_V1_ByNodeid_Floors_ByFloorid;
    public environmental: IbssApiClientV1_V1_ByNodeid_Floors_Environmental;
    public availabilityAndEnvironmental: IbssApiClientV1_V1_ByNodeid_Floors_AvailabilityAndEnvironmental;


    public async get<TResponse>(options: { nodeId: number, top?: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Floors?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Floors_Availability
{

    get<TResponse>(options: { nodeId: number, floorIds?: number[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Floors_Availability implements IIbssApiClientV1_V1_ByNodeid_Floors_Availability
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, floorIds?: number[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.floorIds) { options.floorIds.forEach(i => queryParts.push(`floorIds=${encodeURIComponent(i)}`));}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Floors/availability?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Floors_ByFloorid
{
    availability: IIbssApiClientV1_V1_ByNodeid_Floors_ByFloorid_Availability;
    availabilityAndEnvironmental: IIbssApiClientV1_V1_ByNodeid_Floors_ByFloorid_AvailabilityAndEnvironmental;

    get<TResponse>(options: { nodeId: number, floorid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Floors_ByFloorid implements IIbssApiClientV1_V1_ByNodeid_Floors_ByFloorid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.availability = new IbssApiClientV1_V1_ByNodeid_Floors_ByFloorid_Availability(context);
        this.availabilityAndEnvironmental = new IbssApiClientV1_V1_ByNodeid_Floors_ByFloorid_AvailabilityAndEnvironmental(context);
    }

    public availability: IbssApiClientV1_V1_ByNodeid_Floors_ByFloorid_Availability;
    public availabilityAndEnvironmental: IbssApiClientV1_V1_ByNodeid_Floors_ByFloorid_AvailabilityAndEnvironmental;


    public async get<TResponse>(options: { nodeId: number, floorid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Floors/${options.floorid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Floors_ByFloorid_Availability
{

    get<TResponse>(options: { nodeId: number, floorid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Floors_ByFloorid_Availability implements IIbssApiClientV1_V1_ByNodeid_Floors_ByFloorid_Availability
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, floorid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Floors/${options.floorid}/availability?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Floors_Environmental
{

    get<TResponse>(options: { nodeId: number, recursive?: boolean, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Floors_Environmental implements IIbssApiClientV1_V1_ByNodeid_Floors_Environmental
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Floors/environmental?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Floors_ByFloorid_AvailabilityAndEnvironmental
{

    get<TResponse>(options: { nodeId: number, floorid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Floors_ByFloorid_AvailabilityAndEnvironmental implements IIbssApiClientV1_V1_ByNodeid_Floors_ByFloorid_AvailabilityAndEnvironmental
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, floorid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Floors/${options.floorid}/availability-and-environmental?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Floors_AvailabilityAndEnvironmental
{

    get<TResponse>(options: { nodeId: number, floorIds?: number[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Floors_AvailabilityAndEnvironmental implements IIbssApiClientV1_V1_ByNodeid_Floors_AvailabilityAndEnvironmental
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, floorIds?: number[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.floorIds) { options.floorIds.forEach(i => queryParts.push(`floorIds=${encodeURIComponent(i)}`));}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Floors/availability-and-environmental?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Languages
{
    byLanguageid: IIbssApiClientV1_V1_ByNodeid_Languages_ByLanguageid;

    get<TResponse>(options: { nodeId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Languages implements IIbssApiClientV1_V1_ByNodeid_Languages
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byLanguageid = new IbssApiClientV1_V1_ByNodeid_Languages_ByLanguageid(context);
    }

    public byLanguageid: IbssApiClientV1_V1_ByNodeid_Languages_ByLanguageid;


    public async get<TResponse>(options: { nodeId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Languages?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Languages_ByLanguageid
{

    get<TResponse>(options: { nodeId: number, languageid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Languages_ByLanguageid implements IIbssApiClientV1_V1_ByNodeid_Languages_ByLanguageid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, languageid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Languages/${options.languageid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Lockers
{
    byLockerId: IIbssApiClientV1_V1_ByNodeid_Lockers_ByLockerId;
    lockerbanks: IIbssApiClientV1_V1_ByNodeid_Lockers_Lockerbanks;
    byLockerbankid: IIbssApiClientV1_V1_ByNodeid_Lockers_ByLockerbankid;
    claimed: IIbssApiClientV1_V1_ByNodeid_Lockers_Claimed;


}

export class IbssApiClientV1_V1_ByNodeid_Lockers implements IIbssApiClientV1_V1_ByNodeid_Lockers
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byLockerId = new IbssApiClientV1_V1_ByNodeid_Lockers_ByLockerId(context);
        this.lockerbanks = new IbssApiClientV1_V1_ByNodeid_Lockers_Lockerbanks(context);
        this.byLockerbankid = new IbssApiClientV1_V1_ByNodeid_Lockers_ByLockerbankid(context);
        this.claimed = new IbssApiClientV1_V1_ByNodeid_Lockers_Claimed(context);
    }

    public byLockerId: IbssApiClientV1_V1_ByNodeid_Lockers_ByLockerId;
    public lockerbanks: IbssApiClientV1_V1_ByNodeid_Lockers_Lockerbanks;
    public byLockerbankid: IbssApiClientV1_V1_ByNodeid_Lockers_ByLockerbankid;
    public claimed: IbssApiClientV1_V1_ByNodeid_Lockers_Claimed;


}

export interface IIbssApiClientV1_V1_ByNodeid_Lockers_ByLockerId
{
    claim: IIbssApiClientV1_V1_ByNodeid_Lockers_ByLockerId_Claim;
    unlock: IIbssApiClientV1_V1_ByNodeid_Lockers_ByLockerId_Unlock;
    release: IIbssApiClientV1_V1_ByNodeid_Lockers_ByLockerId_Release;

    get<TResponse>(options: { nodeId: number, lockerId: string, lockerbankid?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Lockers_ByLockerId implements IIbssApiClientV1_V1_ByNodeid_Lockers_ByLockerId
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.claim = new IbssApiClientV1_V1_ByNodeid_Lockers_ByLockerId_Claim(context);
        this.unlock = new IbssApiClientV1_V1_ByNodeid_Lockers_ByLockerId_Unlock(context);
        this.release = new IbssApiClientV1_V1_ByNodeid_Lockers_ByLockerId_Release(context);
    }

    public claim: IbssApiClientV1_V1_ByNodeid_Lockers_ByLockerId_Claim;
    public unlock: IbssApiClientV1_V1_ByNodeid_Lockers_ByLockerId_Unlock;
    public release: IbssApiClientV1_V1_ByNodeid_Lockers_ByLockerId_Release;


    public async get<TResponse>(options: { nodeId: number, lockerId: string, lockerbankid?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.lockerbankid) { queryParts.push(`lockerbankid=${encodeURIComponent(options.lockerbankid)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Lockers/${options.lockerId}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Lockers_Lockerbanks
{

    get<TResponse>(options: { nodeId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Lockers_Lockerbanks implements IIbssApiClientV1_V1_ByNodeid_Lockers_Lockerbanks
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Lockers/Lockerbanks?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Lockers_ByLockerbankid
{
    available: IIbssApiClientV1_V1_ByNodeid_Lockers_ByLockerbankid_Available;


}

export class IbssApiClientV1_V1_ByNodeid_Lockers_ByLockerbankid implements IIbssApiClientV1_V1_ByNodeid_Lockers_ByLockerbankid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.available = new IbssApiClientV1_V1_ByNodeid_Lockers_ByLockerbankid_Available(context);
    }

    public available: IbssApiClientV1_V1_ByNodeid_Lockers_ByLockerbankid_Available;


}

export interface IIbssApiClientV1_V1_ByNodeid_Lockers_ByLockerbankid_Available
{

    get<TResponse>(options: { nodeId: number, lockerbankid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Lockers_ByLockerbankid_Available implements IIbssApiClientV1_V1_ByNodeid_Lockers_ByLockerbankid_Available
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, lockerbankid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Lockers/${options.lockerbankid}/available?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Lockers_Claimed
{

    get<TResponse>(options: { nodeId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Lockers_Claimed implements IIbssApiClientV1_V1_ByNodeid_Lockers_Claimed
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Lockers/claimed?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Lockers_ByLockerId_Claim
{

    post<TResponse>(options: { nodeId: number, lockerId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Lockers_ByLockerId_Claim implements IIbssApiClientV1_V1_ByNodeid_Lockers_ByLockerId_Claim
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { nodeId: number, lockerId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v1/${options.nodeId}/Lockers/${options.lockerId}/claim?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Lockers_ByLockerId_Unlock
{

    put<TResponse>(options: { nodeId: number, lockerId: string, openTime?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Lockers_ByLockerId_Unlock implements IIbssApiClientV1_V1_ByNodeid_Lockers_ByLockerId_Unlock
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, lockerId: string, openTime?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.openTime) { queryParts.push(`openTime=${encodeURIComponent(options.openTime)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/Lockers/${options.lockerId}/unlock?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Lockers_ByLockerId_Release
{

    put<TResponse>(options: { nodeId: number, lockerId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Lockers_ByLockerId_Release implements IIbssApiClientV1_V1_ByNodeid_Lockers_ByLockerId_Release
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, lockerId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/Lockers/${options.lockerId}/release?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Nodes
{

    get<TResponse>(options: { nodeId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Nodes implements IIbssApiClientV1_V1_ByNodeid_Nodes
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Nodes?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_NotificationHubRegister
{
    byId: IIbssApiClientV1_V1_NotificationHubRegister_ById;

    get<TResponse>(options: { skipToken?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { body: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_NotificationHubRegister implements IIbssApiClientV1_V1_NotificationHubRegister
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byId = new IbssApiClientV1_V1_NotificationHubRegister_ById(context);
    }

    public byId: IbssApiClientV1_V1_NotificationHubRegister_ById;


    public async get<TResponse>(options: { skipToken?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.top) { queryParts.push(`top=${encodeURIComponent(options.top)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/NotificationHubRegister?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { body: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v1/NotificationHubRegister?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_NotificationHubRegister_ById
{

    delete<TResponse>(options: { id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { id: string, body: IDeviceRegistration, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_NotificationHubRegister_ById implements IIbssApiClientV1_V1_NotificationHubRegister_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v1/NotificationHubRegister/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { id: string, body: IDeviceRegistration, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/NotificationHubRegister/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Notifications
{
    byNotificationid: IIbssApiClientV1_V1_ByNodeid_Notifications_ByNotificationid;
    byNotificationId: IIbssApiClientV1_V1_ByNodeid_Notifications_ByNotificationId;
    active: IIbssApiClientV1_V1_ByNodeid_Notifications_Active;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, startDate?: string, endDate?: string, schema?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: ICreateNotification, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Notifications implements IIbssApiClientV1_V1_ByNodeid_Notifications
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byNotificationid = new IbssApiClientV1_V1_ByNodeid_Notifications_ByNotificationid(context);
        this.byNotificationId = new IbssApiClientV1_V1_ByNodeid_Notifications_ByNotificationId(context);
        this.active = new IbssApiClientV1_V1_ByNodeid_Notifications_Active(context);
    }

    public byNotificationid: IbssApiClientV1_V1_ByNodeid_Notifications_ByNotificationid;
    public byNotificationId: IbssApiClientV1_V1_ByNodeid_Notifications_ByNotificationId;
    public active: IbssApiClientV1_V1_ByNodeid_Notifications_Active;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, startDate?: string, endDate?: string, schema?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.startDate) { queryParts.push(`startDate=${encodeURIComponent(options.startDate)}`);}
            if (options.endDate) { queryParts.push(`endDate=${encodeURIComponent(options.endDate)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}
            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Notifications?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: ICreateNotification, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v1/${options.nodeId}/Notifications?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Notifications_ByNotificationid
{

    delete<TResponse>(options: { nodeId: number, notificationid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Notifications_ByNotificationid implements IIbssApiClientV1_V1_ByNodeid_Notifications_ByNotificationid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, notificationid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v1/${options.nodeId}/Notifications/${options.notificationid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Notifications_ByNotificationId
{

    get<TResponse>(options: { nodeId: number, notificationId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, notificationId: number, body: IUpdateNotification, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Notifications_ByNotificationId implements IIbssApiClientV1_V1_ByNodeid_Notifications_ByNotificationId
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, notificationId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Notifications/${options.notificationId}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, notificationId: number, body: IUpdateNotification, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/Notifications/${options.notificationId}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Notifications_Active
{

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Notifications_Active implements IIbssApiClientV1_V1_ByNodeid_Notifications_Active
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Notifications/active?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_Organisations
{
    byOrganisationid: IIbssApiClientV1_V1_Organisations_ByOrganisationid;

    get<TResponse>(options: { top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_Organisations implements IIbssApiClientV1_V1_Organisations
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byOrganisationid = new IbssApiClientV1_V1_Organisations_ByOrganisationid(context);
    }

    public byOrganisationid: IbssApiClientV1_V1_Organisations_ByOrganisationid;


    public async get<TResponse>(options: { top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/Organisations?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_Organisations_ByOrganisationid
{

    get<TResponse>(options: { nodeId?: number, organisationid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_Organisations_ByOrganisationid implements IIbssApiClientV1_V1_Organisations_ByOrganisationid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId?: number, organisationid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.nodeId) { queryParts.push(`nodeid=${encodeURIComponent(options.nodeId)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/Organisations/${options.organisationid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Parameters
{
    byParameterId: IIbssApiClientV1_V1_ByNodeid_Parameters_ByParameterId;
    byname: IIbssApiClientV1_V1_ByNodeid_Parameters_Byname;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, orderBy?: string, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: IParameterCreate, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Parameters implements IIbssApiClientV1_V1_ByNodeid_Parameters
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byParameterId = new IbssApiClientV1_V1_ByNodeid_Parameters_ByParameterId(context);
        this.byname = new IbssApiClientV1_V1_ByNodeid_Parameters_Byname(context);
    }

    public byParameterId: IbssApiClientV1_V1_ByNodeid_Parameters_ByParameterId;
    public byname: IbssApiClientV1_V1_ByNodeid_Parameters_Byname;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, orderBy?: string, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Parameters?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: IParameterCreate, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v1/${options.nodeId}/Parameters?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Parameters_ByParameterId
{

    delete<TResponse>(options: { nodeId: number, parameterId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, parameterId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, parameterId: number, body: IParameterCreate, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Parameters_ByParameterId implements IIbssApiClientV1_V1_ByNodeid_Parameters_ByParameterId
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, parameterId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v1/${options.nodeId}/Parameters/${options.parameterId}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, parameterId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Parameters/${options.parameterId}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, parameterId: number, body: IParameterCreate, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/Parameters/${options.parameterId}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Parameters_Byname
{
    byParameterName: IIbssApiClientV1_V1_ByNodeid_Parameters_Byname_ByParameterName;


}

export class IbssApiClientV1_V1_ByNodeid_Parameters_Byname implements IIbssApiClientV1_V1_ByNodeid_Parameters_Byname
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byParameterName = new IbssApiClientV1_V1_ByNodeid_Parameters_Byname_ByParameterName(context);
    }

    public byParameterName: IbssApiClientV1_V1_ByNodeid_Parameters_Byname_ByParameterName;


}

export interface IIbssApiClientV1_V1_ByNodeid_Parameters_Byname_ByParameterName
{

    get<TResponse>(options: { nodeId: number, parameterName: string, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Parameters_Byname_ByParameterName implements IIbssApiClientV1_V1_ByNodeid_Parameters_Byname_ByParameterName
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, parameterName: string, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Parameters/byname/${options.parameterName}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Regions
{
    byRegionid: IIbssApiClientV1_V1_ByNodeid_Regions_ByRegionid;

    get<TResponse>(options: { nodeId: number, top?: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Regions implements IIbssApiClientV1_V1_ByNodeid_Regions
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byRegionid = new IbssApiClientV1_V1_ByNodeid_Regions_ByRegionid(context);
    }

    public byRegionid: IbssApiClientV1_V1_ByNodeid_Regions_ByRegionid;


    public async get<TResponse>(options: { nodeId: number, top?: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Regions?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Regions_ByRegionid
{

    get<TResponse>(options: { nodeId: number, regionid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Regions_ByRegionid implements IIbssApiClientV1_V1_ByNodeid_Regions_ByRegionid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, regionid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Regions/${options.regionid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_ResolversCategories
{

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_ResolversCategories implements IIbssApiClientV1_V1_ByNodeid_ResolversCategories
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/ResolversCategories?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_ResolversDailySummary
{

    get<TResponse>(options: { nodeId: number, top?: number, startDate?: string, endDate?: string, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_ResolversDailySummary implements IIbssApiClientV1_V1_ByNodeid_ResolversDailySummary
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, top?: number, startDate?: string, endDate?: string, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.startDate) { queryParts.push(`startDate=${encodeURIComponent(options.startDate)}`);}
            if (options.endDate) { queryParts.push(`endDate=${encodeURIComponent(options.endDate)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/ResolversDailySummary?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_Service
{
    heartbeat: IIbssApiClientV1_V1_Service_Heartbeat;
    version: IIbssApiClientV1_V1_Service_Version;
    supportedVersion: IIbssApiClientV1_V1_Service_SupportedVersion;
    refreshCache: IIbssApiClientV1_V1_Service_RefreshCache;
    logTrace: IIbssApiClientV1_V1_Service_LogTrace;
    cachedData: IIbssApiClientV1_V1_Service_CachedData;
    privacyPolicy: IIbssApiClientV1_V1_Service_PrivacyPolicy;


}

export class IbssApiClientV1_V1_Service implements IIbssApiClientV1_V1_Service
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.heartbeat = new IbssApiClientV1_V1_Service_Heartbeat(context);
        this.version = new IbssApiClientV1_V1_Service_Version(context);
        this.supportedVersion = new IbssApiClientV1_V1_Service_SupportedVersion(context);
        this.refreshCache = new IbssApiClientV1_V1_Service_RefreshCache(context);
        this.logTrace = new IbssApiClientV1_V1_Service_LogTrace(context);
        this.cachedData = new IbssApiClientV1_V1_Service_CachedData(context);
        this.privacyPolicy = new IbssApiClientV1_V1_Service_PrivacyPolicy(context);
    }

    public heartbeat: IbssApiClientV1_V1_Service_Heartbeat;
    public version: IbssApiClientV1_V1_Service_Version;
    public supportedVersion: IbssApiClientV1_V1_Service_SupportedVersion;
    public refreshCache: IbssApiClientV1_V1_Service_RefreshCache;
    public logTrace: IbssApiClientV1_V1_Service_LogTrace;
    public cachedData: IbssApiClientV1_V1_Service_CachedData;
    public privacyPolicy: IbssApiClientV1_V1_Service_PrivacyPolicy;


}

export interface IIbssApiClientV1_V1_Service_Heartbeat
{

    get<TResponse>(options: { type?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_Service_Heartbeat implements IIbssApiClientV1_V1_Service_Heartbeat
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { type?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.type) { queryParts.push(`type=${encodeURIComponent(options.type)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/Service/heartbeat?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_Service_Version
{

    get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_Service_Version implements IIbssApiClientV1_V1_Service_Version
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/Service/version?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_Service_SupportedVersion
{

    get<TResponse>(options: { oStype?: number, versionNumber?: string, module?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_Service_SupportedVersion implements IIbssApiClientV1_V1_Service_SupportedVersion
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { oStype?: number, versionNumber?: string, module?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.oStype) { queryParts.push(`oSType=${encodeURIComponent(options.oStype)}`);}
            if (options.versionNumber) { queryParts.push(`versionNumber=${encodeURIComponent(options.versionNumber)}`);}
            if (options.module) { queryParts.push(`module=${encodeURIComponent(options.module)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/Service/supported-version?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_Service_RefreshCache
{

    get<TResponse>(options: { nodeId?: number[], type?: EventType, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_Service_RefreshCache implements IIbssApiClientV1_V1_Service_RefreshCache
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId?: number[], type?: EventType, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.nodeId) { options.nodeId.forEach(i => queryParts.push(`nodeId=${encodeURIComponent(i)}`));}
            if (options.type) { queryParts.push(`type=${encodeURIComponent(options.type)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/Service/RefreshCache?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_Service_LogTrace
{

    get<TResponse>(options: { message?: string, level?: TraceLevel, category?: IbssErrorCategoryId, source?: string, controllerId?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_Service_LogTrace implements IIbssApiClientV1_V1_Service_LogTrace
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { message?: string, level?: TraceLevel, category?: IbssErrorCategoryId, source?: string, controllerId?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.message) { queryParts.push(`message=${encodeURIComponent(options.message)}`);}
            if (options.level) { queryParts.push(`level=${encodeURIComponent(options.level)}`);}
            if (options.category) { queryParts.push(`category=${encodeURIComponent(options.category)}`);}
            if (options.source) { queryParts.push(`source=${encodeURIComponent(options.source)}`);}
            if (options.controllerId) { queryParts.push(`controllerId=${encodeURIComponent(options.controllerId)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/Service/LogTrace?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_Service_CachedData
{

    get<TResponse>(options: { type?: EventType, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_Service_CachedData implements IIbssApiClientV1_V1_Service_CachedData
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { type?: EventType, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.type) { queryParts.push(`type=${encodeURIComponent(options.type)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/Service/CachedData?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_Service_PrivacyPolicy
{

    get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_Service_PrivacyPolicy implements IIbssApiClientV1_V1_Service_PrivacyPolicy
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/Service/privacy-policy?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Signage
{
    bySignageId: IIbssApiClientV1_V1_ByNodeid_Signage_BySignageId;

    get<TResponse>(options: { nodeId: number, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: ISignageVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Signage implements IIbssApiClientV1_V1_ByNodeid_Signage
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.bySignageId = new IbssApiClientV1_V1_ByNodeid_Signage_BySignageId(context);
    }

    public bySignageId: IbssApiClientV1_V1_ByNodeid_Signage_BySignageId;


    public async get<TResponse>(options: { nodeId: number, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Signage?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: ISignageVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v1/${options.nodeId}/Signage?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Signage_BySignageId
{

    delete<TResponse>(options: { nodeId: number, signageId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, signageId: number, body: ISignageVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, signageId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Signage_BySignageId implements IIbssApiClientV1_V1_ByNodeid_Signage_BySignageId
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, signageId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v1/${options.nodeId}/Signage/${options.signageId}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, signageId: number, body: ISignageVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/Signage/${options.signageId}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, signageId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Signage/${options.signageId}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_SpaceCateringMenu
{
    bySpaceCateringId: IIbssApiClientV1_V1_ByNodeid_SpaceCateringMenu_BySpaceCateringId;
    bySpacecateringId: IIbssApiClientV1_V1_ByNodeid_SpaceCateringMenu_BySpacecateringId;
    roomService: IIbssApiClientV1_V1_ByNodeid_SpaceCateringMenu_RoomService;
    preBook: IIbssApiClientV1_V1_ByNodeid_SpaceCateringMenu_PreBook;

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, orderBy?: string, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, schema?: boolean, body: ISpaceCateringPostVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_SpaceCateringMenu implements IIbssApiClientV1_V1_ByNodeid_SpaceCateringMenu
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.bySpaceCateringId = new IbssApiClientV1_V1_ByNodeid_SpaceCateringMenu_BySpaceCateringId(context);
        this.bySpacecateringId = new IbssApiClientV1_V1_ByNodeid_SpaceCateringMenu_BySpacecateringId(context);
        this.roomService = new IbssApiClientV1_V1_ByNodeid_SpaceCateringMenu_RoomService(context);
        this.preBook = new IbssApiClientV1_V1_ByNodeid_SpaceCateringMenu_PreBook(context);
    }

    public bySpaceCateringId: IbssApiClientV1_V1_ByNodeid_SpaceCateringMenu_BySpaceCateringId;
    public bySpacecateringId: IbssApiClientV1_V1_ByNodeid_SpaceCateringMenu_BySpacecateringId;
    public roomService: IbssApiClientV1_V1_ByNodeid_SpaceCateringMenu_RoomService;
    public preBook: IbssApiClientV1_V1_ByNodeid_SpaceCateringMenu_PreBook;


    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, orderBy?: string, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/SpaceCateringMenu?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, schema?: boolean, body: ISpaceCateringPostVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v1/${options.nodeId}/SpaceCateringMenu?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_SpaceCateringMenu_BySpaceCateringId
{

    delete<TResponse>(options: { nodeId: number, spaceCateringId: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, spaceCateringId: number, schema?: boolean, body: ISpaceCateringUpdateVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_SpaceCateringMenu_BySpaceCateringId implements IIbssApiClientV1_V1_ByNodeid_SpaceCateringMenu_BySpaceCateringId
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, spaceCateringId: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v1/${options.nodeId}/SpaceCateringMenu/${options.spaceCateringId}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, spaceCateringId: number, schema?: boolean, body: ISpaceCateringUpdateVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/SpaceCateringMenu/${options.spaceCateringId}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_SpaceCateringMenu_BySpacecateringId
{

    get<TResponse>(options: { nodeId: number, spacecateringId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_SpaceCateringMenu_BySpacecateringId implements IIbssApiClientV1_V1_ByNodeid_SpaceCateringMenu_BySpacecateringId
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, spacecateringId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/SpaceCateringMenu/${options.spacecateringId}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_SpaceCateringMenu_RoomService
{

    get<TResponse>(options: { nodeId: number, top?: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_SpaceCateringMenu_RoomService implements IIbssApiClientV1_V1_ByNodeid_SpaceCateringMenu_RoomService
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, top?: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/SpaceCateringMenu/room-service?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_SpaceCateringMenu_PreBook
{

    get<TResponse>(options: { nodeId: number, top?: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_SpaceCateringMenu_PreBook implements IIbssApiClientV1_V1_ByNodeid_SpaceCateringMenu_PreBook
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, top?: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/SpaceCateringMenu/pre-book?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Spaces
{
    bySpaceid: IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid;
    search: IIbssApiClientV1_V1_ByNodeid_Spaces_Search;
    definitions: IIbssApiClientV1_V1_ByNodeid_Spaces_Definitions;
    refresh: IIbssApiClientV1_V1_ByNodeid_Spaces_Refresh;
    bySpaceId: IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceId;
    bookingsToday: IIbssApiClientV1_V1_ByNodeid_Spaces_BookingsToday;
    availability: IIbssApiClientV1_V1_ByNodeid_Spaces_Availability;
    bySpacetype: IIbssApiClientV1_V1_ByNodeid_Spaces_BySpacetype;
    count: IIbssApiClientV1_V1_ByNodeid_Spaces_Count;
    updateSpaceOccupancy: IIbssApiClientV1_V1_ByNodeid_Spaces_UpdateSpaceOccupancy;

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, orderBy?: string, schema?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Spaces implements IIbssApiClientV1_V1_ByNodeid_Spaces
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.bySpaceid = new IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid(context);
        this.search = new IbssApiClientV1_V1_ByNodeid_Spaces_Search(context);
        this.definitions = new IbssApiClientV1_V1_ByNodeid_Spaces_Definitions(context);
        this.refresh = new IbssApiClientV1_V1_ByNodeid_Spaces_Refresh(context);
        this.bySpaceId = new IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceId(context);
        this.bookingsToday = new IbssApiClientV1_V1_ByNodeid_Spaces_BookingsToday(context);
        this.availability = new IbssApiClientV1_V1_ByNodeid_Spaces_Availability(context);
        this.bySpacetype = new IbssApiClientV1_V1_ByNodeid_Spaces_BySpacetype(context);
        this.count = new IbssApiClientV1_V1_ByNodeid_Spaces_Count(context);
        this.updateSpaceOccupancy = new IbssApiClientV1_V1_ByNodeid_Spaces_UpdateSpaceOccupancy(context);
    }

    public bySpaceid: IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid;
    public search: IbssApiClientV1_V1_ByNodeid_Spaces_Search;
    public definitions: IbssApiClientV1_V1_ByNodeid_Spaces_Definitions;
    public refresh: IbssApiClientV1_V1_ByNodeid_Spaces_Refresh;
    public bySpaceId: IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceId;
    public bookingsToday: IbssApiClientV1_V1_ByNodeid_Spaces_BookingsToday;
    public availability: IbssApiClientV1_V1_ByNodeid_Spaces_Availability;
    public bySpacetype: IbssApiClientV1_V1_ByNodeid_Spaces_BySpacetype;
    public count: IbssApiClientV1_V1_ByNodeid_Spaces_Count;
    public updateSpaceOccupancy: IbssApiClientV1_V1_ByNodeid_Spaces_UpdateSpaceOccupancy;


    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, orderBy?: string, schema?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}
            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid
{
    reserve: IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Reserve;
    tasks: IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Tasks;
    schedule: IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Schedule;
    definitions: IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Definitions;
    environmental: IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Environmental;
    bookingsToday: IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_BookingsToday;
    temperature: IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Temperature;
    lighting: IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Lighting;
    avSource: IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_AvSource;
    avDisplay: IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_AvDisplay;
    avVolume: IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_AvVolume;
    blinds: IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Blinds;
    spaceInfo: IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_SpaceInfo;
    spaceAvInfo: IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_SpaceAvInfo;
    createSpaceClean: IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_CreateSpaceClean;
    bookings: IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Bookings;
    checkin: IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Checkin;
    checkout: IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Checkout;
    disable: IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Disable;
    enable: IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Enable;
    setpoint: IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Setpoint;
    action: IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Action;

    get<TResponse>(options: { nodeId: number, clientId?: Client, spaceid: string, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid implements IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.reserve = new IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Reserve(context);
        this.tasks = new IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Tasks(context);
        this.schedule = new IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Schedule(context);
        this.definitions = new IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Definitions(context);
        this.environmental = new IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Environmental(context);
        this.bookingsToday = new IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_BookingsToday(context);
        this.temperature = new IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Temperature(context);
        this.lighting = new IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Lighting(context);
        this.avSource = new IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_AvSource(context);
        this.avDisplay = new IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_AvDisplay(context);
        this.avVolume = new IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_AvVolume(context);
        this.blinds = new IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Blinds(context);
        this.spaceInfo = new IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_SpaceInfo(context);
        this.spaceAvInfo = new IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_SpaceAvInfo(context);
        this.createSpaceClean = new IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_CreateSpaceClean(context);
        this.bookings = new IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Bookings(context);
        this.checkin = new IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Checkin(context);
        this.checkout = new IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Checkout(context);
        this.disable = new IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Disable(context);
        this.enable = new IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Enable(context);
        this.setpoint = new IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Setpoint(context);
        this.action = new IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Action(context);
    }

    public reserve: IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Reserve;
    public tasks: IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Tasks;
    public schedule: IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Schedule;
    public definitions: IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Definitions;
    public environmental: IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Environmental;
    public bookingsToday: IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_BookingsToday;
    public temperature: IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Temperature;
    public lighting: IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Lighting;
    public avSource: IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_AvSource;
    public avDisplay: IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_AvDisplay;
    public avVolume: IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_AvVolume;
    public blinds: IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Blinds;
    public spaceInfo: IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_SpaceInfo;
    public spaceAvInfo: IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_SpaceAvInfo;
    public createSpaceClean: IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_CreateSpaceClean;
    public bookings: IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Bookings;
    public checkin: IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Checkin;
    public checkout: IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Checkout;
    public disable: IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Disable;
    public enable: IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Enable;
    public setpoint: IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Setpoint;
    public action: IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Action;


    public async get<TResponse>(options: { nodeId: number, clientId?: Client, spaceid: string, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.clientId) { queryParts.push(`clientId=${encodeURIComponent(options.clientId)}`);}
            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces/${options.spaceid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Reserve
{

    delete<TResponse>(options: { nodeId: number, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Reserve implements IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Reserve
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces/${options.spaceid}/reserve?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces/${options.spaceid}/reserve?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Tasks
{

    get<TResponse>(options: { nodeId: number, top?: number, clientId?: Client, spaceid: string, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Tasks implements IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Tasks
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, top?: number, clientId?: Client, spaceid: string, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.clientId) { queryParts.push(`clientId=${encodeURIComponent(options.clientId)}`);}
            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces/${options.spaceid}/tasks?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Spaces_Search
{

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, orderBy?: string, schema?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, select: new() => ODataSelect, top?: number, orderBy?: string, showDebugStats?: boolean, body: ISearchRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Spaces_Search implements IIbssApiClientV1_V1_ByNodeid_Spaces_Search
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, orderBy?: string, schema?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}
            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces/search?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, select: new() => ODataSelect, top?: number, orderBy?: string, showDebugStats?: boolean, body: ISearchRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.orderBy) { queryParts.push(`orderBy=${encodeURIComponent(options.orderBy)}`);}
            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces/search?${query}`, options.body, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Schedule
{

    get<TResponse>(options: { nodeId: number, top?: number, clientId?: Client, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Schedule implements IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Schedule
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, top?: number, clientId?: Client, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.clientId) { queryParts.push(`clientId=${encodeURIComponent(options.clientId)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces/${options.spaceid}/schedule?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Spaces_Definitions
{

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Spaces_Definitions implements IIbssApiClientV1_V1_ByNodeid_Spaces_Definitions
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces/definitions?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Spaces_Refresh
{

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, orderBy?: string, clientId?: Client, startDate?: string, endDate?: string, debug?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Spaces_Refresh implements IIbssApiClientV1_V1_ByNodeid_Spaces_Refresh
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, orderBy?: string, clientId?: Client, startDate?: string, endDate?: string, debug?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}
            if (options.clientId) { queryParts.push(`clientId=${encodeURIComponent(options.clientId)}`);}
            if (options.startDate) { queryParts.push(`startDate=${encodeURIComponent(options.startDate)}`);}
            if (options.endDate) { queryParts.push(`endDate=${encodeURIComponent(options.endDate)}`);}
            if (options.debug) { queryParts.push(`debug=${encodeURIComponent(options.debug)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces/refresh?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Definitions
{

    get<TResponse>(options: { nodeId: number, clientId?: Client, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Definitions implements IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Definitions
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, clientId?: Client, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.clientId) { queryParts.push(`clientId=${encodeURIComponent(options.clientId)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces/${options.spaceid}/definitions?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceId
{
    refresh: IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceId_Refresh;
    rawdata: IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceId_Rawdata;


}

export class IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceId implements IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceId
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.refresh = new IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceId_Refresh(context);
        this.rawdata = new IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceId_Rawdata(context);
    }

    public refresh: IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceId_Refresh;
    public rawdata: IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceId_Rawdata;


}

export interface IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceId_Refresh
{

    get<TResponse>(options: { nodeId: number, clientId?: Client, spaceId: string, startDate?: string, endDate?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceId_Refresh implements IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceId_Refresh
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, clientId?: Client, spaceId: string, startDate?: string, endDate?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.clientId) { queryParts.push(`clientId=${encodeURIComponent(options.clientId)}`);}
            if (options.startDate) { queryParts.push(`startDate=${encodeURIComponent(options.startDate)}`);}
            if (options.endDate) { queryParts.push(`endDate=${encodeURIComponent(options.endDate)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces/${options.spaceId}/refresh?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Environmental
{

    get<TResponse>(options: { nodeId: number, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Environmental implements IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Environmental
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces/${options.spaceid}/environmental?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_BookingsToday
{

    get<TResponse>(options: { nodeId: number, top?: number, clientId?: Client, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_BookingsToday implements IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_BookingsToday
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, top?: number, clientId?: Client, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.clientId) { queryParts.push(`clientId=${encodeURIComponent(options.clientId)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces/${options.spaceid}/bookings-today?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Spaces_BookingsToday
{

    get<TResponse>(options: { nodeId: number, top?: number, clientId?: Client, spaceId?: string[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Spaces_BookingsToday implements IIbssApiClientV1_V1_ByNodeid_Spaces_BookingsToday
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, top?: number, clientId?: Client, spaceId?: string[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.clientId) { queryParts.push(`clientId=${encodeURIComponent(options.clientId)}`);}
            if (options.spaceId) { options.spaceId.forEach(i => queryParts.push(`spaceId=${encodeURIComponent(i)}`));}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces/bookings-today?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Spaces_Availability
{

    get<TResponse>(options: { nodeId: number, spaceTypes?: string[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Spaces_Availability implements IIbssApiClientV1_V1_ByNodeid_Spaces_Availability
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, spaceTypes?: string[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.spaceTypes) { options.spaceTypes.forEach(i => queryParts.push(`spaceTypes=${encodeURIComponent(i)}`));}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces/availability?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Spaces_BySpacetype
{
    availability: IIbssApiClientV1_V1_ByNodeid_Spaces_BySpacetype_Availability;


}

export class IbssApiClientV1_V1_ByNodeid_Spaces_BySpacetype implements IIbssApiClientV1_V1_ByNodeid_Spaces_BySpacetype
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.availability = new IbssApiClientV1_V1_ByNodeid_Spaces_BySpacetype_Availability(context);
    }

    public availability: IbssApiClientV1_V1_ByNodeid_Spaces_BySpacetype_Availability;


}

export interface IIbssApiClientV1_V1_ByNodeid_Spaces_BySpacetype_Availability
{

    get<TResponse>(options: { nodeId: number, spacetype: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Spaces_BySpacetype_Availability implements IIbssApiClientV1_V1_ByNodeid_Spaces_BySpacetype_Availability
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, spacetype: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces/${options.spacetype}/availability?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Temperature
{

    get<TResponse>(options: { nodeId: number, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, spaceid: string, body: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Temperature implements IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Temperature
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces/${options.spaceid}/temperature?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, spaceid: string, body: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces/${options.spaceid}/temperature?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Lighting
{

    get<TResponse>(options: { nodeId: number, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, spaceid: string, body: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Lighting implements IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Lighting
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces/${options.spaceid}/lighting?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, spaceid: string, body: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces/${options.spaceid}/lighting?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_AvSource
{

    get<TResponse>(options: { nodeId: number, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, spaceid: string, body: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_AvSource implements IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_AvSource
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces/${options.spaceid}/av-source?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, spaceid: string, body: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces/${options.spaceid}/av-source?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_AvDisplay
{

    get<TResponse>(options: { nodeId: number, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, spaceid: string, body: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_AvDisplay implements IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_AvDisplay
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces/${options.spaceid}/av-display?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, spaceid: string, body: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces/${options.spaceid}/av-display?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_AvVolume
{

    get<TResponse>(options: { nodeId: number, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, spaceid: string, body: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_AvVolume implements IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_AvVolume
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces/${options.spaceid}/av-volume?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, spaceid: string, body: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces/${options.spaceid}/av-volume?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Blinds
{

    get<TResponse>(options: { nodeId: number, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, spaceid: string, body: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Blinds implements IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Blinds
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces/${options.spaceid}/blinds?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, spaceid: string, body: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces/${options.spaceid}/blinds?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_SpaceInfo
{

    get<TResponse>(options: { nodeId: number, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_SpaceInfo implements IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_SpaceInfo
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces/${options.spaceid}/space-info?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_SpaceAvInfo
{

    get<TResponse>(options: { nodeId: number, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_SpaceAvInfo implements IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_SpaceAvInfo
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces/${options.spaceid}/space-av-info?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Spaces_Count
{

    get<TResponse>(options: { nodeId: number, spaceClass?: string, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Spaces_Count implements IIbssApiClientV1_V1_ByNodeid_Spaces_Count
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, spaceClass?: string, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.spaceClass) { queryParts.push(`spaceClass=${encodeURIComponent(options.spaceClass)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces/count?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceId_Rawdata
{
    byDate: IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceId_Rawdata_ByDate;


}

export class IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceId_Rawdata implements IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceId_Rawdata
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byDate = new IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceId_Rawdata_ByDate(context);
    }

    public byDate: IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceId_Rawdata_ByDate;


}

export interface IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceId_Rawdata_ByDate
{

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, top?: number, spaceId: string, date: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceId_Rawdata_ByDate implements IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceId_Rawdata_ByDate
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, top?: number, spaceId: string, date: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces/${options.spaceId}/rawdata/${options.date}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_CreateSpaceClean
{

    post<TResponse>(options: { nodeId: number, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_CreateSpaceClean implements IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_CreateSpaceClean
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { nodeId: number, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces/${options.spaceid}/create-space-clean?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Bookings
{

    post<TResponse>(options: { nodeId: number, top?: number, clientId?: Client, spaceid: string, body: IGetBookingsModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Bookings implements IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Bookings
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { nodeId: number, top?: number, clientId?: Client, spaceid: string, body: IGetBookingsModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.clientId) { queryParts.push(`clientId=${encodeURIComponent(options.clientId)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces/${options.spaceid}/bookings?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Checkin
{

    put<TResponse>(options: { nodeId: number, spaceid: string, bookingOwnerEmail?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Checkin implements IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Checkin
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, spaceid: string, bookingOwnerEmail?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.bookingOwnerEmail) { queryParts.push(`bookingOwnerEmail=${encodeURIComponent(options.bookingOwnerEmail)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces/${options.spaceid}/checkin?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Checkout
{

    put<TResponse>(options: { nodeId: number, spaceid: string, bookingOwnerEmail?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Checkout implements IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Checkout
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, spaceid: string, bookingOwnerEmail?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.bookingOwnerEmail) { queryParts.push(`bookingOwnerEmail=${encodeURIComponent(options.bookingOwnerEmail)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces/${options.spaceid}/checkout?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Disable
{

    put<TResponse>(options: { nodeId: number, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Disable implements IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Disable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces/${options.spaceid}/disable?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Enable
{

    put<TResponse>(options: { nodeId: number, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Enable implements IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Enable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces/${options.spaceid}/enable?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Spaces_UpdateSpaceOccupancy
{

    put<TResponse>(options: { nodeId: number, body: ISpaceOccupancy, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Spaces_UpdateSpaceOccupancy implements IIbssApiClientV1_V1_ByNodeid_Spaces_UpdateSpaceOccupancy
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, body: ISpaceOccupancy, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces/update-space-occupancy?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Setpoint
{

    put<TResponse>(options: { nodeId: number, spaceid: string, body: ISpaceSetPointVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Setpoint implements IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Setpoint
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, spaceid: string, body: ISpaceSetPointVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces/${options.spaceid}/setpoint?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Action
{

    put<TResponse>(options: { nodeId: number, spaceid: string, disableExtUpdate?: boolean, showDebugStats?: boolean, body: ISpaceUpdateActionVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Action implements IIbssApiClientV1_V1_ByNodeid_Spaces_BySpaceid_Action
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, spaceid: string, disableExtUpdate?: boolean, showDebugStats?: boolean, body: ISpaceUpdateActionVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.disableExtUpdate) { queryParts.push(`disableExtUpdate=${encodeURIComponent(options.disableExtUpdate)}`);}
            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/Spaces/${options.spaceid}/action?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_SpacesDailySummary
{
    bySpaceId: IIbssApiClientV1_V1_ByNodeid_SpacesDailySummary_BySpaceId;

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, orderBy?: string, startDate?: string, endDate?: string, isUtc?: boolean, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_SpacesDailySummary implements IIbssApiClientV1_V1_ByNodeid_SpacesDailySummary
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.bySpaceId = new IbssApiClientV1_V1_ByNodeid_SpacesDailySummary_BySpaceId(context);
    }

    public bySpaceId: IbssApiClientV1_V1_ByNodeid_SpacesDailySummary_BySpaceId;


    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, orderBy?: string, startDate?: string, endDate?: string, isUtc?: boolean, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}
            if (options.startDate) { queryParts.push(`startDate=${encodeURIComponent(options.startDate)}`);}
            if (options.endDate) { queryParts.push(`endDate=${encodeURIComponent(options.endDate)}`);}
            if (options.isUtc) { queryParts.push(`isUtc=${encodeURIComponent(options.isUtc)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/SpacesDailySummary?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_SpacesDailySummary_BySpaceId
{

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, orderBy?: string, spaceId: string, startDate?: string, endDate?: string, isUtc?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_SpacesDailySummary_BySpaceId implements IIbssApiClientV1_V1_ByNodeid_SpacesDailySummary_BySpaceId
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, orderBy?: string, spaceId: string, startDate?: string, endDate?: string, isUtc?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}
            if (options.startDate) { queryParts.push(`startDate=${encodeURIComponent(options.startDate)}`);}
            if (options.endDate) { queryParts.push(`endDate=${encodeURIComponent(options.endDate)}`);}
            if (options.isUtc) { queryParts.push(`isUtc=${encodeURIComponent(options.isUtc)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/SpacesDailySummary/${options.spaceId}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_SpacesDailySummary
{
    recalculate: IIbssApiClientV1_V1_SpacesDailySummary_Recalculate;


}

export class IbssApiClientV1_V1_SpacesDailySummary implements IIbssApiClientV1_V1_SpacesDailySummary
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.recalculate = new IbssApiClientV1_V1_SpacesDailySummary_Recalculate(context);
    }

    public recalculate: IbssApiClientV1_V1_SpacesDailySummary_Recalculate;


}

export interface IIbssApiClientV1_V1_SpacesDailySummary_Recalculate
{

    get<TResponse>(options: { nodeId?: number, startDate?: string, endDate?: string, apiVersion?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_SpacesDailySummary_Recalculate implements IIbssApiClientV1_V1_SpacesDailySummary_Recalculate
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId?: number, startDate?: string, endDate?: string, apiVersion?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.nodeId) { queryParts.push(`nodeId=${encodeURIComponent(options.nodeId)}`);}
            if (options.startDate) { queryParts.push(`startDate=${encodeURIComponent(options.startDate)}`);}
            if (options.endDate) { queryParts.push(`endDate=${encodeURIComponent(options.endDate)}`);}
            if (options.apiVersion) { queryParts.push(`api-version=${encodeURIComponent(options.apiVersion)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/SpacesDailySummary/Recalculate?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_SpacesSummary
{
    bySpaceId: IIbssApiClientV1_V1_ByNodeid_SpacesSummary_BySpaceId;

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, orderBy?: string, startDate?: string, endDate?: string, isUtc?: boolean, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_SpacesSummary implements IIbssApiClientV1_V1_ByNodeid_SpacesSummary
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.bySpaceId = new IbssApiClientV1_V1_ByNodeid_SpacesSummary_BySpaceId(context);
    }

    public bySpaceId: IbssApiClientV1_V1_ByNodeid_SpacesSummary_BySpaceId;


    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, orderBy?: string, startDate?: string, endDate?: string, isUtc?: boolean, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.orderBy) { queryParts.push(`$orderBy=${encodeURIComponent(options.orderBy)}`);}
            if (options.startDate) { queryParts.push(`startDate=${encodeURIComponent(options.startDate)}`);}
            if (options.endDate) { queryParts.push(`endDate=${encodeURIComponent(options.endDate)}`);}
            if (options.isUtc) { queryParts.push(`isUtc=${encodeURIComponent(options.isUtc)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/SpacesSummary?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_SpacesSummary_BySpaceId
{

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, orderBy?: string, spaceId: string, startDate?: string, endDate?: string, isUtc?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_SpacesSummary_BySpaceId implements IIbssApiClientV1_V1_ByNodeid_SpacesSummary_BySpaceId
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, orderBy?: string, spaceId: string, startDate?: string, endDate?: string, isUtc?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.orderBy) { queryParts.push(`$orderBy=${encodeURIComponent(options.orderBy)}`);}
            if (options.startDate) { queryParts.push(`startDate=${encodeURIComponent(options.startDate)}`);}
            if (options.endDate) { queryParts.push(`endDate=${encodeURIComponent(options.endDate)}`);}
            if (options.isUtc) { queryParts.push(`isUtc=${encodeURIComponent(options.isUtc)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/SpacesSummary/${options.spaceId}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_SpacesSummary
{
    recalculate: IIbssApiClientV1_V1_SpacesSummary_Recalculate;


}

export class IbssApiClientV1_V1_SpacesSummary implements IIbssApiClientV1_V1_SpacesSummary
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.recalculate = new IbssApiClientV1_V1_SpacesSummary_Recalculate(context);
    }

    public recalculate: IbssApiClientV1_V1_SpacesSummary_Recalculate;


}

export interface IIbssApiClientV1_V1_SpacesSummary_Recalculate
{

    get<TResponse>(options: { nodeId?: number, startDate?: string, endDate?: string, apiVersion?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_SpacesSummary_Recalculate implements IIbssApiClientV1_V1_SpacesSummary_Recalculate
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId?: number, startDate?: string, endDate?: string, apiVersion?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.nodeId) { queryParts.push(`nodeId=${encodeURIComponent(options.nodeId)}`);}
            if (options.startDate) { queryParts.push(`startDate=${encodeURIComponent(options.startDate)}`);}
            if (options.endDate) { queryParts.push(`endDate=${encodeURIComponent(options.endDate)}`);}
            if (options.apiVersion) { queryParts.push(`api-version=${encodeURIComponent(options.apiVersion)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/SpacesSummary/Recalculate?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_SpaceStates
{
    bySpacestateid: IIbssApiClientV1_V1_ByNodeid_SpaceStates_BySpacestateid;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: ISpaceStatePost, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_SpaceStates implements IIbssApiClientV1_V1_ByNodeid_SpaceStates
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.bySpacestateid = new IbssApiClientV1_V1_ByNodeid_SpaceStates_BySpacestateid(context);
    }

    public bySpacestateid: IbssApiClientV1_V1_ByNodeid_SpaceStates_BySpacestateid;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/SpaceStates?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: ISpaceStatePost, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v1/${options.nodeId}/SpaceStates?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_SpaceStates_BySpacestateid
{
    states: IIbssApiClientV1_V1_ByNodeid_SpaceStates_BySpacestateid_States;

    delete<TResponse>(options: { nodeId: number, spacestateid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, spacestateid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, spacestateid: string, body: ISpaceStateUpdate, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_SpaceStates_BySpacestateid implements IIbssApiClientV1_V1_ByNodeid_SpaceStates_BySpacestateid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.states = new IbssApiClientV1_V1_ByNodeid_SpaceStates_BySpacestateid_States(context);
    }

    public states: IbssApiClientV1_V1_ByNodeid_SpaceStates_BySpacestateid_States;


    public async delete<TResponse>(options: { nodeId: number, spacestateid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v1/${options.nodeId}/SpaceStates/${options.spacestateid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, spacestateid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/SpaceStates/${options.spacestateid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, spacestateid: string, body: ISpaceStateUpdate, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/SpaceStates/${options.spacestateid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_SpaceStates_BySpacestateid_States
{

    get<TResponse>(options: { nodeId: number, spacestateid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_SpaceStates_BySpacestateid_States implements IIbssApiClientV1_V1_ByNodeid_SpaceStates_BySpacestateid_States
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, spacestateid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/SpaceStates/${options.spacestateid}/states?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_SpaceUtilisation
{
    byStartDate: IIbssApiClientV1_V1_ByNodeid_SpaceUtilisation_ByStartDate;
    spaceUtilisationData: IIbssApiClientV1_V1_ByNodeid_SpaceUtilisation_SpaceUtilisationData;


}

export class IbssApiClientV1_V1_ByNodeid_SpaceUtilisation implements IIbssApiClientV1_V1_ByNodeid_SpaceUtilisation
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byStartDate = new IbssApiClientV1_V1_ByNodeid_SpaceUtilisation_ByStartDate(context);
        this.spaceUtilisationData = new IbssApiClientV1_V1_ByNodeid_SpaceUtilisation_SpaceUtilisationData(context);
    }

    public byStartDate: IbssApiClientV1_V1_ByNodeid_SpaceUtilisation_ByStartDate;
    public spaceUtilisationData: IbssApiClientV1_V1_ByNodeid_SpaceUtilisation_SpaceUtilisationData;


}

export interface IIbssApiClientV1_V1_ByNodeid_SpaceUtilisation_ByStartDate
{
    byEndDate: IIbssApiClientV1_V1_ByNodeid_SpaceUtilisation_ByStartDate_ByEndDate;


}

export class IbssApiClientV1_V1_ByNodeid_SpaceUtilisation_ByStartDate implements IIbssApiClientV1_V1_ByNodeid_SpaceUtilisation_ByStartDate
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byEndDate = new IbssApiClientV1_V1_ByNodeid_SpaceUtilisation_ByStartDate_ByEndDate(context);
    }

    public byEndDate: IbssApiClientV1_V1_ByNodeid_SpaceUtilisation_ByStartDate_ByEndDate;


}

export interface IIbssApiClientV1_V1_ByNodeid_SpaceUtilisation_ByStartDate_ByEndDate
{
    spaceUtilisationData: IIbssApiClientV1_V1_ByNodeid_SpaceUtilisation_ByStartDate_ByEndDate_SpaceUtilisationData;


}

export class IbssApiClientV1_V1_ByNodeid_SpaceUtilisation_ByStartDate_ByEndDate implements IIbssApiClientV1_V1_ByNodeid_SpaceUtilisation_ByStartDate_ByEndDate
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.spaceUtilisationData = new IbssApiClientV1_V1_ByNodeid_SpaceUtilisation_ByStartDate_ByEndDate_SpaceUtilisationData(context);
    }

    public spaceUtilisationData: IbssApiClientV1_V1_ByNodeid_SpaceUtilisation_ByStartDate_ByEndDate_SpaceUtilisationData;


}

export interface IIbssApiClientV1_V1_ByNodeid_SpaceUtilisation_ByStartDate_ByEndDate_SpaceUtilisationData
{

    get<TResponse>(options: { nodeId: number, recursive?: boolean, startDate: string, endDate: string, periodType?: number, nodeLevelName?: string, spaceId?: string, spaceClass?: string, spaceType?: string, orderBy?: string, isUtc?: boolean, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_SpaceUtilisation_ByStartDate_ByEndDate_SpaceUtilisationData implements IIbssApiClientV1_V1_ByNodeid_SpaceUtilisation_ByStartDate_ByEndDate_SpaceUtilisationData
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, startDate: string, endDate: string, periodType?: number, nodeLevelName?: string, spaceId?: string, spaceClass?: string, spaceType?: string, orderBy?: string, isUtc?: boolean, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            if (options.periodType) { queryParts.push(`periodType=${encodeURIComponent(options.periodType)}`);}
            if (options.nodeLevelName) { queryParts.push(`nodeLevelName=${encodeURIComponent(options.nodeLevelName)}`);}
            if (options.spaceId) { queryParts.push(`spaceId=${encodeURIComponent(options.spaceId)}`);}
            if (options.spaceClass) { queryParts.push(`spaceClass=${encodeURIComponent(options.spaceClass)}`);}
            if (options.spaceType) { queryParts.push(`spaceType=${encodeURIComponent(options.spaceType)}`);}
            if (options.orderBy) { queryParts.push(`orderBy=${encodeURIComponent(options.orderBy)}`);}
            if (options.isUtc) { queryParts.push(`isUtc=${encodeURIComponent(options.isUtc)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/SpaceUtilisation/${options.startDate}/${options.endDate}/SpaceUtilisationData?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_SpaceUtilisation_SpaceUtilisationData
{

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_SpaceUtilisation_SpaceUtilisationData implements IIbssApiClientV1_V1_ByNodeid_SpaceUtilisation_SpaceUtilisationData
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/SpaceUtilisation/SpaceUtilisationData?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_SpaceZones
{
    bySpacezoneid: IIbssApiClientV1_V1_ByNodeid_SpaceZones_BySpacezoneid;

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: ISpaceZonePost, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_SpaceZones implements IIbssApiClientV1_V1_ByNodeid_SpaceZones
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.bySpacezoneid = new IbssApiClientV1_V1_ByNodeid_SpaceZones_BySpacezoneid(context);
    }

    public bySpacezoneid: IbssApiClientV1_V1_ByNodeid_SpaceZones_BySpacezoneid;


    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/SpaceZones?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: ISpaceZonePost, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v1/${options.nodeId}/SpaceZones?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_SpaceZones_BySpacezoneid
{

    delete<TResponse>(options: { nodeId: number, spacezoneid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, spacezoneid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, spacezoneid: number, body: ISpaceZonePost, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_SpaceZones_BySpacezoneid implements IIbssApiClientV1_V1_ByNodeid_SpaceZones_BySpacezoneid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, spacezoneid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v1/${options.nodeId}/SpaceZones/${options.spacezoneid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, spacezoneid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/SpaceZones/${options.spacezoneid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, spacezoneid: number, body: ISpaceZonePost, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/SpaceZones/${options.spacezoneid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_SupportedVersions
{
    bySupportedversionid: IIbssApiClientV1_V1_ByNodeid_SupportedVersions_BySupportedversionid;

    get<TResponse>(options: { nodeId: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, schema?: boolean, body: ISupportedVersionPostModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_SupportedVersions implements IIbssApiClientV1_V1_ByNodeid_SupportedVersions
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.bySupportedversionid = new IbssApiClientV1_V1_ByNodeid_SupportedVersions_BySupportedversionid(context);
    }

    public bySupportedversionid: IbssApiClientV1_V1_ByNodeid_SupportedVersions_BySupportedversionid;


    public async get<TResponse>(options: { nodeId: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/SupportedVersions?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, schema?: boolean, body: ISupportedVersionPostModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v1/${options.nodeId}/SupportedVersions?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_SupportedVersions_BySupportedversionid
{

    delete<TResponse>(options: { nodeId: number, supportedversionid: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, supportedversionid: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, supportedversionid: number, schema?: boolean, body: ISupportedVersionPutModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_SupportedVersions_BySupportedversionid implements IIbssApiClientV1_V1_ByNodeid_SupportedVersions_BySupportedversionid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, supportedversionid: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v1/${options.nodeId}/SupportedVersions/${options.supportedversionid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, supportedversionid: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/SupportedVersions/${options.supportedversionid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, supportedversionid: number, schema?: boolean, body: ISupportedVersionPutModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/SupportedVersions/${options.supportedversionid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_TaskCategories
{
    byTaskCategoryName: IIbssApiClientV1_V1_ByNodeid_TaskCategories_ByTaskCategoryName;
    byCategoryId: IIbssApiClientV1_V1_ByNodeid_TaskCategories_ByCategoryId;
    byTaskCategoryId: IIbssApiClientV1_V1_ByNodeid_TaskCategories_ByTaskCategoryId;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_TaskCategories implements IIbssApiClientV1_V1_ByNodeid_TaskCategories
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byTaskCategoryName = new IbssApiClientV1_V1_ByNodeid_TaskCategories_ByTaskCategoryName(context);
        this.byCategoryId = new IbssApiClientV1_V1_ByNodeid_TaskCategories_ByCategoryId(context);
        this.byTaskCategoryId = new IbssApiClientV1_V1_ByNodeid_TaskCategories_ByTaskCategoryId(context);
    }

    public byTaskCategoryName: IbssApiClientV1_V1_ByNodeid_TaskCategories_ByTaskCategoryName;
    public byCategoryId: IbssApiClientV1_V1_ByNodeid_TaskCategories_ByCategoryId;
    public byTaskCategoryId: IbssApiClientV1_V1_ByNodeid_TaskCategories_ByTaskCategoryId;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/TaskCategories?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v1/${options.nodeId}/TaskCategories?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_TaskCategories_ByTaskCategoryName
{

    delete<TResponse>(options: { nodeId: number, taskCategoryName: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_TaskCategories_ByTaskCategoryName implements IIbssApiClientV1_V1_ByNodeid_TaskCategories_ByTaskCategoryName
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, taskCategoryName: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v1/${options.nodeId}/TaskCategories/${options.taskCategoryName}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_TaskCategories_ByCategoryId
{

    delete<TResponse>(options: { nodeId: number, categoryId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, categoryId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_TaskCategories_ByCategoryId implements IIbssApiClientV1_V1_ByNodeid_TaskCategories_ByCategoryId
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, categoryId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v1/${options.nodeId}/TaskCategories/${options.categoryId}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, categoryId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/TaskCategories/${options.categoryId}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_TaskCategories_ByTaskCategoryId
{
    enable: IIbssApiClientV1_V1_ByNodeid_TaskCategories_ByTaskCategoryId_Enable;
    update: IIbssApiClientV1_V1_ByNodeid_TaskCategories_ByTaskCategoryId_Update;
    disable: IIbssApiClientV1_V1_ByNodeid_TaskCategories_ByTaskCategoryId_Disable;

    put<TResponse>(options: { nodeId: number, spaceType?: SpaceTypes, taskCategoryId: string, body: ITaskCategoriesUpdate, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_TaskCategories_ByTaskCategoryId implements IIbssApiClientV1_V1_ByNodeid_TaskCategories_ByTaskCategoryId
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.enable = new IbssApiClientV1_V1_ByNodeid_TaskCategories_ByTaskCategoryId_Enable(context);
        this.update = new IbssApiClientV1_V1_ByNodeid_TaskCategories_ByTaskCategoryId_Update(context);
        this.disable = new IbssApiClientV1_V1_ByNodeid_TaskCategories_ByTaskCategoryId_Disable(context);
    }

    public enable: IbssApiClientV1_V1_ByNodeid_TaskCategories_ByTaskCategoryId_Enable;
    public update: IbssApiClientV1_V1_ByNodeid_TaskCategories_ByTaskCategoryId_Update;
    public disable: IbssApiClientV1_V1_ByNodeid_TaskCategories_ByTaskCategoryId_Disable;


    public async put<TResponse>(options: { nodeId: number, spaceType?: SpaceTypes, taskCategoryId: string, body: ITaskCategoriesUpdate, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.spaceType) { queryParts.push(`spaceType=${encodeURIComponent(options.spaceType)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/TaskCategories/${options.taskCategoryId}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_TaskCategories_ByTaskCategoryId_Enable
{

    put<TResponse>(options: { nodeId: number, taskCategoryId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_TaskCategories_ByTaskCategoryId_Enable implements IIbssApiClientV1_V1_ByNodeid_TaskCategories_ByTaskCategoryId_Enable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, taskCategoryId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/TaskCategories/${options.taskCategoryId}/enable?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_TaskCategories_ByTaskCategoryId_Update
{

    put<TResponse>(options: { nodeId: number, spaceType?: SpaceTypes, taskCategoryId: string, body: ITaskCategoriesUpdate, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_TaskCategories_ByTaskCategoryId_Update implements IIbssApiClientV1_V1_ByNodeid_TaskCategories_ByTaskCategoryId_Update
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, spaceType?: SpaceTypes, taskCategoryId: string, body: ITaskCategoriesUpdate, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.spaceType) { queryParts.push(`spaceType=${encodeURIComponent(options.spaceType)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/TaskCategories/${options.taskCategoryId}/update?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_TaskCategories_ByTaskCategoryId_Disable
{

    put<TResponse>(options: { nodeId: number, taskCategoryId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_TaskCategories_ByTaskCategoryId_Disable implements IIbssApiClientV1_V1_ByNodeid_TaskCategories_ByTaskCategoryId_Disable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, taskCategoryId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/TaskCategories/${options.taskCategoryId}/disable?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Tasks
{
    history: IIbssApiClientV1_V1_ByNodeid_Tasks_History;
    userTasks: IIbssApiClientV1_V1_ByNodeid_Tasks_UserTasks;
    active: IIbssApiClientV1_V1_ByNodeid_Tasks_Active;
    byTaskid: IIbssApiClientV1_V1_ByNodeid_Tasks_ByTaskid;
    userSummary: IIbssApiClientV1_V1_ByNodeid_Tasks_UserSummary;
    download: IIbssApiClientV1_V1_ByNodeid_Tasks_Download;
    byTaskId: IIbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId;

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, showDebugBeforePost?: boolean, showDebugStats?: boolean, body: ITaskCreate, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Tasks implements IIbssApiClientV1_V1_ByNodeid_Tasks
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.history = new IbssApiClientV1_V1_ByNodeid_Tasks_History(context);
        this.userTasks = new IbssApiClientV1_V1_ByNodeid_Tasks_UserTasks(context);
        this.active = new IbssApiClientV1_V1_ByNodeid_Tasks_Active(context);
        this.byTaskid = new IbssApiClientV1_V1_ByNodeid_Tasks_ByTaskid(context);
        this.userSummary = new IbssApiClientV1_V1_ByNodeid_Tasks_UserSummary(context);
        this.download = new IbssApiClientV1_V1_ByNodeid_Tasks_Download(context);
        this.byTaskId = new IbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId(context);
    }

    public history: IbssApiClientV1_V1_ByNodeid_Tasks_History;
    public userTasks: IbssApiClientV1_V1_ByNodeid_Tasks_UserTasks;
    public active: IbssApiClientV1_V1_ByNodeid_Tasks_Active;
    public byTaskid: IbssApiClientV1_V1_ByNodeid_Tasks_ByTaskid;
    public userSummary: IbssApiClientV1_V1_ByNodeid_Tasks_UserSummary;
    public download: IbssApiClientV1_V1_ByNodeid_Tasks_Download;
    public byTaskId: IbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId;


    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Tasks?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, showDebugBeforePost?: boolean, showDebugStats?: boolean, body: ITaskCreate, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.showDebugBeforePost) { queryParts.push(`showDebugBeforePost=${encodeURIComponent(options.showDebugBeforePost)}`);}
            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v1/${options.nodeId}/Tasks?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Tasks_History
{

    get<TResponse>(options: { nodeId: number, top?: number, clientId?: Client, startDate?: string, endDate?: string, schema?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Tasks_History implements IIbssApiClientV1_V1_ByNodeid_Tasks_History
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, top?: number, clientId?: Client, startDate?: string, endDate?: string, schema?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.clientId) { queryParts.push(`clientId=${encodeURIComponent(options.clientId)}`);}
            if (options.startDate) { queryParts.push(`startDate=${encodeURIComponent(options.startDate)}`);}
            if (options.endDate) { queryParts.push(`endDate=${encodeURIComponent(options.endDate)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}
            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Tasks/history?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Tasks_UserTasks
{

    get<TResponse>(options: { nodeId: number, top?: number, clientId?: Client, username?: string, schema?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Tasks_UserTasks implements IIbssApiClientV1_V1_ByNodeid_Tasks_UserTasks
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, top?: number, clientId?: Client, username?: string, schema?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.clientId) { queryParts.push(`clientId=${encodeURIComponent(options.clientId)}`);}
            if (options.username) { queryParts.push(`username=${encodeURIComponent(options.username)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}
            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Tasks/user-tasks?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Tasks_Active
{

    get<TResponse>(options: { nodeId: number, top?: number, clientId?: Client, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Tasks_Active implements IIbssApiClientV1_V1_ByNodeid_Tasks_Active
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, top?: number, clientId?: Client, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.clientId) { queryParts.push(`clientId=${encodeURIComponent(options.clientId)}`);}
            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Tasks/active?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Tasks_ByTaskid
{
    history: IIbssApiClientV1_V1_ByNodeid_Tasks_ByTaskid_History;
    refresh: IIbssApiClientV1_V1_ByNodeid_Tasks_ByTaskid_Refresh;

    get<TResponse>(options: { nodeId: number, taskid: string, schema?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Tasks_ByTaskid implements IIbssApiClientV1_V1_ByNodeid_Tasks_ByTaskid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.history = new IbssApiClientV1_V1_ByNodeid_Tasks_ByTaskid_History(context);
        this.refresh = new IbssApiClientV1_V1_ByNodeid_Tasks_ByTaskid_Refresh(context);
    }

    public history: IbssApiClientV1_V1_ByNodeid_Tasks_ByTaskid_History;
    public refresh: IbssApiClientV1_V1_ByNodeid_Tasks_ByTaskid_Refresh;


    public async get<TResponse>(options: { nodeId: number, taskid: string, schema?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}
            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Tasks/${options.taskid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Tasks_ByTaskid_History
{

    get<TResponse>(options: { nodeId: number, clientId?: Client, taskid: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Tasks_ByTaskid_History implements IIbssApiClientV1_V1_ByNodeid_Tasks_ByTaskid_History
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, clientId?: Client, taskid: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.clientId) { queryParts.push(`clientId=${encodeURIComponent(options.clientId)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Tasks/${options.taskid}/history?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Tasks_UserSummary
{

    get<TResponse>(options: { nodeId: number, clientId?: Client, username?: string, schema?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Tasks_UserSummary implements IIbssApiClientV1_V1_ByNodeid_Tasks_UserSummary
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, clientId?: Client, username?: string, schema?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.clientId) { queryParts.push(`clientId=${encodeURIComponent(options.clientId)}`);}
            if (options.username) { queryParts.push(`username=${encodeURIComponent(options.username)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}
            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Tasks/user-summary?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Tasks_ByTaskid_Refresh
{

    get<TResponse>(options: { nodeId: number, clientId?: Client, taskid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Tasks_ByTaskid_Refresh implements IIbssApiClientV1_V1_ByNodeid_Tasks_ByTaskid_Refresh
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, clientId?: Client, taskid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.clientId) { queryParts.push(`clientId=${encodeURIComponent(options.clientId)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Tasks/${options.taskid}/refresh?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Tasks_Download
{

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Tasks_Download implements IIbssApiClientV1_V1_ByNodeid_Tasks_Download
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Tasks/download?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId
{
    assign: IIbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_Assign;
    reAllocate: IIbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_ReAllocate;
    cancel: IIbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_Cancel;
    setInProgress: IIbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_SetInProgress;
    unassign: IIbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_Unassign;
    resolve: IIbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_Resolve;
    changePriority: IIbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_ChangePriority;
    comment: IIbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_Comment;

    put<TResponse>(options: { nodeId: number, taskId: number, disableExtUpdate?: boolean, showDebugStats?: boolean, body: ITaskUpdateVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId implements IIbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.assign = new IbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_Assign(context);
        this.reAllocate = new IbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_ReAllocate(context);
        this.cancel = new IbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_Cancel(context);
        this.setInProgress = new IbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_SetInProgress(context);
        this.unassign = new IbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_Unassign(context);
        this.resolve = new IbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_Resolve(context);
        this.changePriority = new IbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_ChangePriority(context);
        this.comment = new IbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_Comment(context);
    }

    public assign: IbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_Assign;
    public reAllocate: IbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_ReAllocate;
    public cancel: IbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_Cancel;
    public setInProgress: IbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_SetInProgress;
    public unassign: IbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_Unassign;
    public resolve: IbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_Resolve;
    public changePriority: IbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_ChangePriority;
    public comment: IbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_Comment;


    public async put<TResponse>(options: { nodeId: number, taskId: number, disableExtUpdate?: boolean, showDebugStats?: boolean, body: ITaskUpdateVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.disableExtUpdate) { queryParts.push(`disableExtUpdate=${encodeURIComponent(options.disableExtUpdate)}`);}
            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/Tasks/${options.taskId}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_Assign
{

    put<TResponse>(options: { nodeId: number, taskId: number, disableExtUpdate?: boolean, body: ITasksAssign, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_Assign implements IIbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_Assign
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, taskId: number, disableExtUpdate?: boolean, body: ITasksAssign, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.disableExtUpdate) { queryParts.push(`disableExtUpdate=${encodeURIComponent(options.disableExtUpdate)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/Tasks/${options.taskId}/assign?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_ReAllocate
{

    put<TResponse>(options: { nodeId: number, taskId: number, disableExtUpdate?: boolean, body: ITaskReAllocate, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_ReAllocate implements IIbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_ReAllocate
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, taskId: number, disableExtUpdate?: boolean, body: ITaskReAllocate, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.disableExtUpdate) { queryParts.push(`disableExtUpdate=${encodeURIComponent(options.disableExtUpdate)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/Tasks/${options.taskId}/re-allocate?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_Cancel
{

    put<TResponse>(options: { nodeId: number, taskId: number, disableExtUpdate?: boolean, taskResolveDescription?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_Cancel implements IIbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_Cancel
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, taskId: number, disableExtUpdate?: boolean, taskResolveDescription?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.disableExtUpdate) { queryParts.push(`disableExtUpdate=${encodeURIComponent(options.disableExtUpdate)}`);}
            if (options.taskResolveDescription) { queryParts.push(`taskResolveDescription=${encodeURIComponent(options.taskResolveDescription)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/Tasks/${options.taskId}/cancel?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_SetInProgress
{

    put<TResponse>(options: { nodeId: number, taskId: number, disableExtUpdate?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_SetInProgress implements IIbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_SetInProgress
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, taskId: number, disableExtUpdate?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.disableExtUpdate) { queryParts.push(`disableExtUpdate=${encodeURIComponent(options.disableExtUpdate)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/Tasks/${options.taskId}/set-in-progress?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_Unassign
{

    put<TResponse>(options: { nodeId: number, taskId: number, disableExtUpdate?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_Unassign implements IIbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_Unassign
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, taskId: number, disableExtUpdate?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.disableExtUpdate) { queryParts.push(`disableExtUpdate=${encodeURIComponent(options.disableExtUpdate)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/Tasks/${options.taskId}/unassign?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_Resolve
{

    put<TResponse>(options: { nodeId: number, taskId: number, disableExtUpdate?: boolean, body: ITaskResolve, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_Resolve implements IIbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_Resolve
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, taskId: number, disableExtUpdate?: boolean, body: ITaskResolve, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.disableExtUpdate) { queryParts.push(`disableExtUpdate=${encodeURIComponent(options.disableExtUpdate)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/Tasks/${options.taskId}/resolve?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_ChangePriority
{

    put<TResponse>(options: { nodeId: number, taskId: number, disableExtUpdate?: boolean, body: ITaskPriority, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_ChangePriority implements IIbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_ChangePriority
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, taskId: number, disableExtUpdate?: boolean, body: ITaskPriority, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.disableExtUpdate) { queryParts.push(`disableExtUpdate=${encodeURIComponent(options.disableExtUpdate)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/Tasks/${options.taskId}/change-priority?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_Comment
{

    put<TResponse>(options: { nodeId: number, taskId: number, body: ITaskComment, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_Comment implements IIbssApiClientV1_V1_ByNodeid_Tasks_ByTaskId_Comment
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, taskId: number, body: ITaskComment, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/Tasks/${options.taskId}​/comment?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_TasksDailySummary
{
    recalculate: IIbssApiClientV1_V1_ByNodeid_TasksDailySummary_Recalculate;

    get<TResponse>(options: { nodeId: number, top?: number, startDate?: string, endDate?: string, isUtc?: boolean, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_TasksDailySummary implements IIbssApiClientV1_V1_ByNodeid_TasksDailySummary
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.recalculate = new IbssApiClientV1_V1_ByNodeid_TasksDailySummary_Recalculate(context);
    }

    public recalculate: IbssApiClientV1_V1_ByNodeid_TasksDailySummary_Recalculate;


    public async get<TResponse>(options: { nodeId: number, top?: number, startDate?: string, endDate?: string, isUtc?: boolean, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.startDate) { queryParts.push(`startDate=${encodeURIComponent(options.startDate)}`);}
            if (options.endDate) { queryParts.push(`endDate=${encodeURIComponent(options.endDate)}`);}
            if (options.isUtc) { queryParts.push(`isUtc=${encodeURIComponent(options.isUtc)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/TasksDailySummary?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_TasksDailySummary_Recalculate
{

    get<TResponse>(options: { nodeId: number, startDate?: string, endDate?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_TasksDailySummary_Recalculate implements IIbssApiClientV1_V1_ByNodeid_TasksDailySummary_Recalculate
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, startDate?: string, endDate?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.startDate) { queryParts.push(`startDate=${encodeURIComponent(options.startDate)}`);}
            if (options.endDate) { queryParts.push(`endDate=${encodeURIComponent(options.endDate)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/TasksDailySummary/Recalculate?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_TaskStates
{
    byTaskstateid: IIbssApiClientV1_V1_ByNodeid_TaskStates_ByTaskstateid;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: ITaskStatePostModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_TaskStates implements IIbssApiClientV1_V1_ByNodeid_TaskStates
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byTaskstateid = new IbssApiClientV1_V1_ByNodeid_TaskStates_ByTaskstateid(context);
    }

    public byTaskstateid: IbssApiClientV1_V1_ByNodeid_TaskStates_ByTaskstateid;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/TaskStates?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: ITaskStatePostModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v1/${options.nodeId}/TaskStates?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_TaskStates_ByTaskstateid
{

    delete<TResponse>(options: { nodeId: number, taskstateid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, taskstateid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, taskstateid: string, body: ITaskStateUpdate, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_TaskStates_ByTaskstateid implements IIbssApiClientV1_V1_ByNodeid_TaskStates_ByTaskstateid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, taskstateid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v1/${options.nodeId}/TaskStates/${options.taskstateid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, taskstateid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/TaskStates/${options.taskstateid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, taskstateid: string, body: ITaskStateUpdate, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/TaskStates/${options.taskstateid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_TaskTypes
{
    byTaskTypeId: IIbssApiClientV1_V1_ByNodeid_TaskTypes_ByTaskTypeId;
    byTasktypeid: IIbssApiClientV1_V1_ByNodeid_TaskTypes_ByTasktypeid;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: ITaskTypeCreateModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_TaskTypes implements IIbssApiClientV1_V1_ByNodeid_TaskTypes
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byTaskTypeId = new IbssApiClientV1_V1_ByNodeid_TaskTypes_ByTaskTypeId(context);
        this.byTasktypeid = new IbssApiClientV1_V1_ByNodeid_TaskTypes_ByTasktypeid(context);
    }

    public byTaskTypeId: IbssApiClientV1_V1_ByNodeid_TaskTypes_ByTaskTypeId;
    public byTasktypeid: IbssApiClientV1_V1_ByNodeid_TaskTypes_ByTasktypeid;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/TaskTypes?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: ITaskTypeCreateModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v1/${options.nodeId}/TaskTypes?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_TaskTypes_ByTaskTypeId
{

    delete<TResponse>(options: { nodeId: number, taskTypeId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_TaskTypes_ByTaskTypeId implements IIbssApiClientV1_V1_ByNodeid_TaskTypes_ByTaskTypeId
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, taskTypeId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v1/${options.nodeId}/TaskTypes/${options.taskTypeId}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_TaskTypes_ByTasktypeid
{
    enable: IIbssApiClientV1_V1_ByNodeid_TaskTypes_ByTasktypeid_Enable;
    disable: IIbssApiClientV1_V1_ByNodeid_TaskTypes_ByTasktypeid_Disable;

    get<TResponse>(options: { nodeId: number, tasktypeid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, tasktypeid: string, body: ITaskTypeUpdateModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_TaskTypes_ByTasktypeid implements IIbssApiClientV1_V1_ByNodeid_TaskTypes_ByTasktypeid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.enable = new IbssApiClientV1_V1_ByNodeid_TaskTypes_ByTasktypeid_Enable(context);
        this.disable = new IbssApiClientV1_V1_ByNodeid_TaskTypes_ByTasktypeid_Disable(context);
    }

    public enable: IbssApiClientV1_V1_ByNodeid_TaskTypes_ByTasktypeid_Enable;
    public disable: IbssApiClientV1_V1_ByNodeid_TaskTypes_ByTasktypeid_Disable;


    public async get<TResponse>(options: { nodeId: number, tasktypeid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/TaskTypes/${options.tasktypeid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, tasktypeid: string, body: ITaskTypeUpdateModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/TaskTypes/${options.tasktypeid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_TaskTypes_ByTasktypeid_Enable
{

    put<TResponse>(options: { nodeId: number, tasktypeid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_TaskTypes_ByTasktypeid_Enable implements IIbssApiClientV1_V1_ByNodeid_TaskTypes_ByTasktypeid_Enable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, tasktypeid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/TaskTypes/${options.tasktypeid}/enable?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_TaskTypes_ByTasktypeid_Disable
{

    put<TResponse>(options: { nodeId: number, tasktypeid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_TaskTypes_ByTasktypeid_Disable implements IIbssApiClientV1_V1_ByNodeid_TaskTypes_ByTasktypeid_Disable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, tasktypeid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/TaskTypes/${options.tasktypeid}/disable?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_TrackAndTrace
{
    location: IIbssApiClientV1_V1_ByNodeid_TrackAndTrace_Location;
    trackAndTraceCounts: IIbssApiClientV1_V1_ByNodeid_TrackAndTrace_TrackAndTraceCounts;


}

export class IbssApiClientV1_V1_ByNodeid_TrackAndTrace implements IIbssApiClientV1_V1_ByNodeid_TrackAndTrace
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.location = new IbssApiClientV1_V1_ByNodeid_TrackAndTrace_Location(context);
        this.trackAndTraceCounts = new IbssApiClientV1_V1_ByNodeid_TrackAndTrace_TrackAndTraceCounts(context);
    }

    public location: IbssApiClientV1_V1_ByNodeid_TrackAndTrace_Location;
    public trackAndTraceCounts: IbssApiClientV1_V1_ByNodeid_TrackAndTrace_TrackAndTraceCounts;


}

export interface IIbssApiClientV1_V1_ByNodeid_TrackAndTrace_Location
{

    post<TResponse>(options: { nodeId: number, schema?: boolean, body: IRequestModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_TrackAndTrace_Location implements IIbssApiClientV1_V1_ByNodeid_TrackAndTrace_Location
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { nodeId: number, schema?: boolean, body: IRequestModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v1/${options.nodeId}/TrackAndTrace/location?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_TrackAndTrace_TrackAndTraceCounts
{

    post<TResponse>(options: { nodeId: number, schema?: boolean, body: IRequestModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_TrackAndTrace_TrackAndTraceCounts implements IIbssApiClientV1_V1_ByNodeid_TrackAndTrace_TrackAndTraceCounts
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { nodeId: number, schema?: boolean, body: IRequestModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v1/${options.nodeId}/TrackAndTrace/trackAndTraceCounts?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_UserNotifications
{
    byUsernotificationId: IIbssApiClientV1_V1_ByNodeid_UserNotifications_ByUsernotificationId;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_UserNotifications implements IIbssApiClientV1_V1_ByNodeid_UserNotifications
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byUsernotificationId = new IbssApiClientV1_V1_ByNodeid_UserNotifications_ByUsernotificationId(context);
    }

    public byUsernotificationId: IbssApiClientV1_V1_ByNodeid_UserNotifications_ByUsernotificationId;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/UserNotifications?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_UserNotifications_ByUsernotificationId
{

    get<TResponse>(options: { nodeId: number, usernotificationId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    patch<TResponse>(options: { nodeId: number, usernotificationId: string, body: INotificationStatus, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_UserNotifications_ByUsernotificationId implements IIbssApiClientV1_V1_ByNodeid_UserNotifications_ByUsernotificationId
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, usernotificationId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/UserNotifications/${options.usernotificationId}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { nodeId: number, usernotificationId: string, body: INotificationStatus, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v1/${options.nodeId}/UserNotifications/${options.usernotificationId}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_UserPreferences
{
    bySpaceId: IIbssApiClientV1_V1_ByNodeid_UserPreferences_BySpaceId;
    byEquipId: IIbssApiClientV1_V1_ByNodeid_UserPreferences_ByEquipId;
    byUsername: IIbssApiClientV1_V1_ByNodeid_UserPreferences_ByUsername;
    updateNotifications: IIbssApiClientV1_V1_ByNodeid_UserPreferences_UpdateNotifications;
    updatePrivacy: IIbssApiClientV1_V1_ByNodeid_UserPreferences_UpdatePrivacy;
    updateEnvironment: IIbssApiClientV1_V1_ByNodeid_UserPreferences_UpdateEnvironment;
    updateWorkinghours: IIbssApiClientV1_V1_ByNodeid_UserPreferences_UpdateWorkinghours;
    updateSearchprefs: IIbssApiClientV1_V1_ByNodeid_UserPreferences_UpdateSearchprefs;
    byFloor: IIbssApiClientV1_V1_ByNodeid_UserPreferences_ByFloor;
    updateCalendarprefs: IIbssApiClientV1_V1_ByNodeid_UserPreferences_UpdateCalendarprefs;
    updateDiagnosticsprefs: IIbssApiClientV1_V1_ByNodeid_UserPreferences_UpdateDiagnosticsprefs;

    get<TResponse>(options: { nodeId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, body: IUserPrefUpdateModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_UserPreferences implements IIbssApiClientV1_V1_ByNodeid_UserPreferences
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.bySpaceId = new IbssApiClientV1_V1_ByNodeid_UserPreferences_BySpaceId(context);
        this.byEquipId = new IbssApiClientV1_V1_ByNodeid_UserPreferences_ByEquipId(context);
        this.byUsername = new IbssApiClientV1_V1_ByNodeid_UserPreferences_ByUsername(context);
        this.updateNotifications = new IbssApiClientV1_V1_ByNodeid_UserPreferences_UpdateNotifications(context);
        this.updatePrivacy = new IbssApiClientV1_V1_ByNodeid_UserPreferences_UpdatePrivacy(context);
        this.updateEnvironment = new IbssApiClientV1_V1_ByNodeid_UserPreferences_UpdateEnvironment(context);
        this.updateWorkinghours = new IbssApiClientV1_V1_ByNodeid_UserPreferences_UpdateWorkinghours(context);
        this.updateSearchprefs = new IbssApiClientV1_V1_ByNodeid_UserPreferences_UpdateSearchprefs(context);
        this.byFloor = new IbssApiClientV1_V1_ByNodeid_UserPreferences_ByFloor(context);
        this.updateCalendarprefs = new IbssApiClientV1_V1_ByNodeid_UserPreferences_UpdateCalendarprefs(context);
        this.updateDiagnosticsprefs = new IbssApiClientV1_V1_ByNodeid_UserPreferences_UpdateDiagnosticsprefs(context);
    }

    public bySpaceId: IbssApiClientV1_V1_ByNodeid_UserPreferences_BySpaceId;
    public byEquipId: IbssApiClientV1_V1_ByNodeid_UserPreferences_ByEquipId;
    public byUsername: IbssApiClientV1_V1_ByNodeid_UserPreferences_ByUsername;
    public updateNotifications: IbssApiClientV1_V1_ByNodeid_UserPreferences_UpdateNotifications;
    public updatePrivacy: IbssApiClientV1_V1_ByNodeid_UserPreferences_UpdatePrivacy;
    public updateEnvironment: IbssApiClientV1_V1_ByNodeid_UserPreferences_UpdateEnvironment;
    public updateWorkinghours: IbssApiClientV1_V1_ByNodeid_UserPreferences_UpdateWorkinghours;
    public updateSearchprefs: IbssApiClientV1_V1_ByNodeid_UserPreferences_UpdateSearchprefs;
    public byFloor: IbssApiClientV1_V1_ByNodeid_UserPreferences_ByFloor;
    public updateCalendarprefs: IbssApiClientV1_V1_ByNodeid_UserPreferences_UpdateCalendarprefs;
    public updateDiagnosticsprefs: IbssApiClientV1_V1_ByNodeid_UserPreferences_UpdateDiagnosticsprefs;


    public async get<TResponse>(options: { nodeId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/UserPreferences?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, body: IUserPrefUpdateModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/UserPreferences?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_UserPreferences_BySpaceId
{
    favouriteSpace: IIbssApiClientV1_V1_ByNodeid_UserPreferences_BySpaceId_FavouriteSpace;


}

export class IbssApiClientV1_V1_ByNodeid_UserPreferences_BySpaceId implements IIbssApiClientV1_V1_ByNodeid_UserPreferences_BySpaceId
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.favouriteSpace = new IbssApiClientV1_V1_ByNodeid_UserPreferences_BySpaceId_FavouriteSpace(context);
    }

    public favouriteSpace: IbssApiClientV1_V1_ByNodeid_UserPreferences_BySpaceId_FavouriteSpace;


}

export interface IIbssApiClientV1_V1_ByNodeid_UserPreferences_BySpaceId_FavouriteSpace
{

    delete<TResponse>(options: { nodeId: number, spaceId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, spaceId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_UserPreferences_BySpaceId_FavouriteSpace implements IIbssApiClientV1_V1_ByNodeid_UserPreferences_BySpaceId_FavouriteSpace
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, spaceId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v1/${options.nodeId}/UserPreferences/${options.spaceId}/favourite-space?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, spaceId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v1/${options.nodeId}/UserPreferences/${options.spaceId}/favourite-space?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_UserPreferences_ByEquipId
{
    favouriteEquipment: IIbssApiClientV1_V1_ByNodeid_UserPreferences_ByEquipId_FavouriteEquipment;


}

export class IbssApiClientV1_V1_ByNodeid_UserPreferences_ByEquipId implements IIbssApiClientV1_V1_ByNodeid_UserPreferences_ByEquipId
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.favouriteEquipment = new IbssApiClientV1_V1_ByNodeid_UserPreferences_ByEquipId_FavouriteEquipment(context);
    }

    public favouriteEquipment: IbssApiClientV1_V1_ByNodeid_UserPreferences_ByEquipId_FavouriteEquipment;


}

export interface IIbssApiClientV1_V1_ByNodeid_UserPreferences_ByEquipId_FavouriteEquipment
{

    delete<TResponse>(options: { nodeId: number, equipId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, equipId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_UserPreferences_ByEquipId_FavouriteEquipment implements IIbssApiClientV1_V1_ByNodeid_UserPreferences_ByEquipId_FavouriteEquipment
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, equipId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v1/${options.nodeId}/UserPreferences/${options.equipId}/favourite-equipment?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, equipId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v1/${options.nodeId}/UserPreferences/${options.equipId}/favourite-equipment?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_UserPreferences_ByUsername
{
    favouriteColleagues: IIbssApiClientV1_V1_ByNodeid_UserPreferences_ByUsername_FavouriteColleagues;


}

export class IbssApiClientV1_V1_ByNodeid_UserPreferences_ByUsername implements IIbssApiClientV1_V1_ByNodeid_UserPreferences_ByUsername
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.favouriteColleagues = new IbssApiClientV1_V1_ByNodeid_UserPreferences_ByUsername_FavouriteColleagues(context);
    }

    public favouriteColleagues: IbssApiClientV1_V1_ByNodeid_UserPreferences_ByUsername_FavouriteColleagues;


}

export interface IIbssApiClientV1_V1_ByNodeid_UserPreferences_ByUsername_FavouriteColleagues
{

    delete<TResponse>(options: { nodeId: number, username: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, username: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_UserPreferences_ByUsername_FavouriteColleagues implements IIbssApiClientV1_V1_ByNodeid_UserPreferences_ByUsername_FavouriteColleagues
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, username: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v1/${options.nodeId}/UserPreferences/${options.username}/favourite-colleagues?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, username: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v1/${options.nodeId}/UserPreferences/${options.username}/favourite-colleagues?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_UserPreferences_UpdateNotifications
{

    put<TResponse>(options: { nodeId: number, body: INotificationsPrefModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_UserPreferences_UpdateNotifications implements IIbssApiClientV1_V1_ByNodeid_UserPreferences_UpdateNotifications
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, body: INotificationsPrefModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/UserPreferences/update-notifications?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_UserPreferences_UpdatePrivacy
{

    put<TResponse>(options: { nodeId: number, body: IPrivacyPrefsModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_UserPreferences_UpdatePrivacy implements IIbssApiClientV1_V1_ByNodeid_UserPreferences_UpdatePrivacy
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, body: IPrivacyPrefsModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/UserPreferences/update-privacy?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_UserPreferences_UpdateEnvironment
{

    put<TResponse>(options: { nodeId: number, body: IEnvironmentPrefsModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_UserPreferences_UpdateEnvironment implements IIbssApiClientV1_V1_ByNodeid_UserPreferences_UpdateEnvironment
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, body: IEnvironmentPrefsModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/UserPreferences/update-environment?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_UserPreferences_UpdateWorkinghours
{

    put<TResponse>(options: { nodeId: number, body: IWorkingHoursPrefsModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_UserPreferences_UpdateWorkinghours implements IIbssApiClientV1_V1_ByNodeid_UserPreferences_UpdateWorkinghours
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, body: IWorkingHoursPrefsModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/UserPreferences/update-workinghours?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_UserPreferences_UpdateSearchprefs
{

    put<TResponse>(options: { nodeId: number, body: ISearchPrefsModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_UserPreferences_UpdateSearchprefs implements IIbssApiClientV1_V1_ByNodeid_UserPreferences_UpdateSearchprefs
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, body: ISearchPrefsModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/UserPreferences/update-searchprefs?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_UserPreferences_ByFloor
{
    updatedefaultfloor: IIbssApiClientV1_V1_ByNodeid_UserPreferences_ByFloor_Updatedefaultfloor;


}

export class IbssApiClientV1_V1_ByNodeid_UserPreferences_ByFloor implements IIbssApiClientV1_V1_ByNodeid_UserPreferences_ByFloor
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.updatedefaultfloor = new IbssApiClientV1_V1_ByNodeid_UserPreferences_ByFloor_Updatedefaultfloor(context);
    }

    public updatedefaultfloor: IbssApiClientV1_V1_ByNodeid_UserPreferences_ByFloor_Updatedefaultfloor;


}

export interface IIbssApiClientV1_V1_ByNodeid_UserPreferences_ByFloor_Updatedefaultfloor
{

    put<TResponse>(options: { nodeId: number, floor: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_UserPreferences_ByFloor_Updatedefaultfloor implements IIbssApiClientV1_V1_ByNodeid_UserPreferences_ByFloor_Updatedefaultfloor
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, floor: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/UserPreferences/${options.floor}/updatedefaultfloor?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_UserPreferences_UpdateCalendarprefs
{

    put<TResponse>(options: { nodeId: number, body: ISyncCalenderPrefsModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_UserPreferences_UpdateCalendarprefs implements IIbssApiClientV1_V1_ByNodeid_UserPreferences_UpdateCalendarprefs
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, body: ISyncCalenderPrefsModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/UserPreferences/update-calendarprefs?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_UserPreferences_UpdateDiagnosticsprefs
{

    put<TResponse>(options: { nodeId: number, body: IDiagnosticsPrefsModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_UserPreferences_UpdateDiagnosticsprefs implements IIbssApiClientV1_V1_ByNodeid_UserPreferences_UpdateDiagnosticsprefs
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, body: IDiagnosticsPrefsModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/UserPreferences/update-diagnosticsprefs?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_Users
{
    byUsername: IIbssApiClientV1_V1_Users_ByUsername;
    accessPass: IIbssApiClientV1_V1_Users_AccessPass;
    byName: IIbssApiClientV1_V1_Users_ByName;
    bySearch: IIbssApiClientV1_V1_Users_BySearch;
    byUserid: IIbssApiClientV1_V1_Users_ByUserid;


}

export class IbssApiClientV1_V1_Users implements IIbssApiClientV1_V1_Users
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byUsername = new IbssApiClientV1_V1_Users_ByUsername(context);
        this.accessPass = new IbssApiClientV1_V1_Users_AccessPass(context);
        this.byName = new IbssApiClientV1_V1_Users_ByName(context);
        this.bySearch = new IbssApiClientV1_V1_Users_BySearch(context);
        this.byUserid = new IbssApiClientV1_V1_Users_ByUserid(context);
    }

    public byUsername: IbssApiClientV1_V1_Users_ByUsername;
    public accessPass: IbssApiClientV1_V1_Users_AccessPass;
    public byName: IbssApiClientV1_V1_Users_ByName;
    public bySearch: IbssApiClientV1_V1_Users_BySearch;
    public byUserid: IbssApiClientV1_V1_Users_ByUserid;


}

export interface IIbssApiClientV1_V1_Users_ByUsername
{
    location: IIbssApiClientV1_V1_Users_ByUsername_Location;


}

export class IbssApiClientV1_V1_Users_ByUsername implements IIbssApiClientV1_V1_Users_ByUsername
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.location = new IbssApiClientV1_V1_Users_ByUsername_Location(context);
    }

    public location: IbssApiClientV1_V1_Users_ByUsername_Location;


}

export interface IIbssApiClientV1_V1_Users_ByUsername_Location
{

    delete<TResponse>(options: { username: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { username: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { username: string, body: IUserLocationRequestModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_Users_ByUsername_Location implements IIbssApiClientV1_V1_Users_ByUsername_Location
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { username: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v1/Users/${options.username}/location?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { username: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/Users/${options.username}/location?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { username: string, body: IUserLocationRequestModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/Users/${options.username}/location?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_Users_AccessPass
{
    byBuildingid: IIbssApiClientV1_V1_Users_AccessPass_ByBuildingid;

    get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { body: IAccessPass, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_Users_AccessPass implements IIbssApiClientV1_V1_Users_AccessPass
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byBuildingid = new IbssApiClientV1_V1_Users_AccessPass_ByBuildingid(context);
    }

    public byBuildingid: IbssApiClientV1_V1_Users_AccessPass_ByBuildingid;


    public async get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/Users/access-pass?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { body: IAccessPass, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v1/Users/access-pass?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_Users_AccessPass_ByBuildingid
{

    delete<TResponse>(options: { buildingid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { buildingid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_Users_AccessPass_ByBuildingid implements IIbssApiClientV1_V1_Users_AccessPass_ByBuildingid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { buildingid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v1/Users/access-pass/${options.buildingid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { buildingid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/Users/access-pass/${options.buildingid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_Users_ByName
{
    checkPin: IIbssApiClientV1_V1_Users_ByName_CheckPin;

    get<TResponse>(options: { name: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_Users_ByName implements IIbssApiClientV1_V1_Users_ByName
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.checkPin = new IbssApiClientV1_V1_Users_ByName_CheckPin(context);
    }

    public checkPin: IbssApiClientV1_V1_Users_ByName_CheckPin;


    public async get<TResponse>(options: { name: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/Users/${options.name}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_Users_BySearch
{
    search: IIbssApiClientV1_V1_Users_BySearch_Search;


}

export class IbssApiClientV1_V1_Users_BySearch implements IIbssApiClientV1_V1_Users_BySearch
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.search = new IbssApiClientV1_V1_Users_BySearch_Search(context);
    }

    public search: IbssApiClientV1_V1_Users_BySearch_Search;


}

export interface IIbssApiClientV1_V1_Users_BySearch_Search
{

    get<TResponse>(options: { search: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_Users_BySearch_Search implements IIbssApiClientV1_V1_Users_BySearch_Search
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { search: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/Users/${options.search}/search?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_Users_ByName_CheckPin
{

    post<TResponse>(options: { name: string, body: IUserPin, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_Users_ByName_CheckPin implements IIbssApiClientV1_V1_Users_ByName_CheckPin
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { name: string, body: IUserPin, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v1/Users/${options.name}/check-pin?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_Users_ByUserid
{
    accessPass: IIbssApiClientV1_V1_Users_ByUserid_AccessPass;


}

export class IbssApiClientV1_V1_Users_ByUserid implements IIbssApiClientV1_V1_Users_ByUserid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.accessPass = new IbssApiClientV1_V1_Users_ByUserid_AccessPass(context);
    }

    public accessPass: IbssApiClientV1_V1_Users_ByUserid_AccessPass;


}

export interface IIbssApiClientV1_V1_Users_ByUserid_AccessPass
{

    post<TResponse>(options: { userid: string, body: IAccessPass, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_Users_ByUserid_AccessPass implements IIbssApiClientV1_V1_Users_ByUserid_AccessPass
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { userid: string, body: IAccessPass, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v1/Users/${options.userid}/access-pass?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Visits
{
    download: IIbssApiClientV1_V1_ByNodeid_Visits_Download;
    byVisitid: IIbssApiClientV1_V1_ByNodeid_Visits_ByVisitid;
    active: IIbssApiClientV1_V1_ByNodeid_Visits_Active;
    inactive: IIbssApiClientV1_V1_ByNodeid_Visits_Inactive;
    awaitingApproval: IIbssApiClientV1_V1_ByNodeid_Visits_AwaitingApproval;
    checkedIn: IIbssApiClientV1_V1_ByNodeid_Visits_CheckedIn;
    import: IIbssApiClientV1_V1_ByNodeid_Visits_Import;

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, schema?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, clientId?: Client, owner?: string, schema?: boolean, showDebugStats?: boolean, body: IPostVisitVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Visits implements IIbssApiClientV1_V1_ByNodeid_Visits
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.download = new IbssApiClientV1_V1_ByNodeid_Visits_Download(context);
        this.byVisitid = new IbssApiClientV1_V1_ByNodeid_Visits_ByVisitid(context);
        this.active = new IbssApiClientV1_V1_ByNodeid_Visits_Active(context);
        this.inactive = new IbssApiClientV1_V1_ByNodeid_Visits_Inactive(context);
        this.awaitingApproval = new IbssApiClientV1_V1_ByNodeid_Visits_AwaitingApproval(context);
        this.checkedIn = new IbssApiClientV1_V1_ByNodeid_Visits_CheckedIn(context);
        this.import = new IbssApiClientV1_V1_ByNodeid_Visits_Import(context);
    }

    public download: IbssApiClientV1_V1_ByNodeid_Visits_Download;
    public byVisitid: IbssApiClientV1_V1_ByNodeid_Visits_ByVisitid;
    public active: IbssApiClientV1_V1_ByNodeid_Visits_Active;
    public inactive: IbssApiClientV1_V1_ByNodeid_Visits_Inactive;
    public awaitingApproval: IbssApiClientV1_V1_ByNodeid_Visits_AwaitingApproval;
    public checkedIn: IbssApiClientV1_V1_ByNodeid_Visits_CheckedIn;
    public import: IbssApiClientV1_V1_ByNodeid_Visits_Import;


    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, schema?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}
            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Visits?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, clientId?: Client, owner?: string, schema?: boolean, showDebugStats?: boolean, body: IPostVisitVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.clientId) { queryParts.push(`clientId=${encodeURIComponent(options.clientId)}`);}
            if (options.owner) { queryParts.push(`owner=${encodeURIComponent(options.owner)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}
            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v1/${options.nodeId}/Visits?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Visits_Download
{

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Visits_Download implements IIbssApiClientV1_V1_ByNodeid_Visits_Download
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Visits/download?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Visits_ByVisitid
{
    checkedIn: IIbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_CheckedIn;
    approve: IIbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_Approve;
    deny: IIbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_Deny;
    cancel: IIbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_Cancel;
    checkin: IIbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_Checkin;
    checkout: IIbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_Checkout;
    userUpdate: IIbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_UserUpdate;
    action: IIbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_Action;

    get<TResponse>(options: { nodeId: number, visitid: string, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, visitid: string, clientId?: Client, owner?: string, schema?: boolean, showDebugStats?: boolean, body: IPutVisitVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Visits_ByVisitid implements IIbssApiClientV1_V1_ByNodeid_Visits_ByVisitid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.checkedIn = new IbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_CheckedIn(context);
        this.approve = new IbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_Approve(context);
        this.deny = new IbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_Deny(context);
        this.cancel = new IbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_Cancel(context);
        this.checkin = new IbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_Checkin(context);
        this.checkout = new IbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_Checkout(context);
        this.userUpdate = new IbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_UserUpdate(context);
        this.action = new IbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_Action(context);
    }

    public checkedIn: IbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_CheckedIn;
    public approve: IbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_Approve;
    public deny: IbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_Deny;
    public cancel: IbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_Cancel;
    public checkin: IbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_Checkin;
    public checkout: IbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_Checkout;
    public userUpdate: IbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_UserUpdate;
    public action: IbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_Action;


    public async get<TResponse>(options: { nodeId: number, visitid: string, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Visits/${options.visitid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, visitid: string, clientId?: Client, owner?: string, schema?: boolean, showDebugStats?: boolean, body: IPutVisitVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.clientId) { queryParts.push(`clientId=${encodeURIComponent(options.clientId)}`);}
            if (options.owner) { queryParts.push(`owner=${encodeURIComponent(options.owner)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}
            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/Visits/${options.visitid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_CheckedIn
{

    get<TResponse>(options: { nodeId: number, clientId?: Client, visitid: string, schema?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_CheckedIn implements IIbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_CheckedIn
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, clientId?: Client, visitid: string, schema?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.clientId) { queryParts.push(`clientId=${encodeURIComponent(options.clientId)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}
            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Visits/${options.visitid}/checked-in?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Visits_Active
{

    get<TResponse>(options: { nodeId: number, top?: number, clientId?: Client, startDate?: string, endDate?: string, schema?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Visits_Active implements IIbssApiClientV1_V1_ByNodeid_Visits_Active
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, top?: number, clientId?: Client, startDate?: string, endDate?: string, schema?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.clientId) { queryParts.push(`clientId=${encodeURIComponent(options.clientId)}`);}
            if (options.startDate) { queryParts.push(`startDate=${encodeURIComponent(options.startDate)}`);}
            if (options.endDate) { queryParts.push(`endDate=${encodeURIComponent(options.endDate)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}
            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Visits/active?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Visits_Inactive
{

    get<TResponse>(options: { nodeId: number, top?: number, clientId?: Client, startDate?: string, endDate?: string, schema?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Visits_Inactive implements IIbssApiClientV1_V1_ByNodeid_Visits_Inactive
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, top?: number, clientId?: Client, startDate?: string, endDate?: string, schema?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.clientId) { queryParts.push(`clientId=${encodeURIComponent(options.clientId)}`);}
            if (options.startDate) { queryParts.push(`startDate=${encodeURIComponent(options.startDate)}`);}
            if (options.endDate) { queryParts.push(`endDate=${encodeURIComponent(options.endDate)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}
            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Visits/inactive?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Visits_AwaitingApproval
{

    get<TResponse>(options: { nodeId: number, top?: number, clientId?: Client, schema?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Visits_AwaitingApproval implements IIbssApiClientV1_V1_ByNodeid_Visits_AwaitingApproval
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, top?: number, clientId?: Client, schema?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.clientId) { queryParts.push(`clientId=${encodeURIComponent(options.clientId)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}
            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Visits/awaiting-approval?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Visits_CheckedIn
{

    get<TResponse>(options: { nodeId: number, clientId?: Client, schema?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Visits_CheckedIn implements IIbssApiClientV1_V1_ByNodeid_Visits_CheckedIn
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, clientId?: Client, schema?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.clientId) { queryParts.push(`clientId=${encodeURIComponent(options.clientId)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}
            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/Visits/checked-in?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Visits_Import
{

    post<TResponse>(options: { nodeId: number, body: any, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Visits_Import implements IIbssApiClientV1_V1_ByNodeid_Visits_Import
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { nodeId: number, body: any, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v1/${options.nodeId}/Visits/import?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_Approve
{

    put<TResponse>(options: { nodeId: number, visitid: string, disableExtUpdate?: boolean, clientId?: Client, schema?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_Approve implements IIbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_Approve
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, visitid: string, disableExtUpdate?: boolean, clientId?: Client, schema?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.disableExtUpdate) { queryParts.push(`disableExtUpdate=${encodeURIComponent(options.disableExtUpdate)}`);}
            if (options.clientId) { queryParts.push(`clientId=${encodeURIComponent(options.clientId)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}
            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/Visits/${options.visitid}/approve?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_Deny
{

    put<TResponse>(options: { nodeId: number, visitid: string, disableExtUpdate?: boolean, clientId?: Client, schema?: boolean, showDebugStats?: boolean, body: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_Deny implements IIbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_Deny
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, visitid: string, disableExtUpdate?: boolean, clientId?: Client, schema?: boolean, showDebugStats?: boolean, body: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.disableExtUpdate) { queryParts.push(`disableExtUpdate=${encodeURIComponent(options.disableExtUpdate)}`);}
            if (options.clientId) { queryParts.push(`clientId=${encodeURIComponent(options.clientId)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}
            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/Visits/${options.visitid}/deny?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_Cancel
{

    put<TResponse>(options: { nodeId: number, visitid: string, disableExtUpdate?: boolean, clientId?: Client, schema?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_Cancel implements IIbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_Cancel
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, visitid: string, disableExtUpdate?: boolean, clientId?: Client, schema?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.disableExtUpdate) { queryParts.push(`disableExtUpdate=${encodeURIComponent(options.disableExtUpdate)}`);}
            if (options.clientId) { queryParts.push(`clientId=${encodeURIComponent(options.clientId)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}
            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/Visits/${options.visitid}/cancel?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_Checkin
{

    put<TResponse>(options: { nodeId: number, visitid: string, disableExtUpdate?: boolean, clientId?: Client, schema?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_Checkin implements IIbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_Checkin
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, visitid: string, disableExtUpdate?: boolean, clientId?: Client, schema?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.disableExtUpdate) { queryParts.push(`disableExtUpdate=${encodeURIComponent(options.disableExtUpdate)}`);}
            if (options.clientId) { queryParts.push(`clientId=${encodeURIComponent(options.clientId)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}
            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/Visits/${options.visitid}/checkin?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_Checkout
{

    put<TResponse>(options: { nodeId: number, visitid: string, disableExtUpdate?: boolean, clientId?: Client, schema?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_Checkout implements IIbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_Checkout
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, visitid: string, disableExtUpdate?: boolean, clientId?: Client, schema?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.disableExtUpdate) { queryParts.push(`disableExtUpdate=${encodeURIComponent(options.disableExtUpdate)}`);}
            if (options.clientId) { queryParts.push(`clientId=${encodeURIComponent(options.clientId)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}
            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/Visits/${options.visitid}/checkout?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_UserUpdate
{

    put<TResponse>(options: { nodeId: number, visitid: string, clientId?: Client, schema?: boolean, showDebugStats?: boolean, body: IVisitUserUpdatesVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_UserUpdate implements IIbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_UserUpdate
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, visitid: string, clientId?: Client, schema?: boolean, showDebugStats?: boolean, body: IVisitUserUpdatesVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.clientId) { queryParts.push(`clientId=${encodeURIComponent(options.clientId)}`);}
            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}
            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/Visits/${options.visitid}/user-update?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_Action
{

    put<TResponse>(options: { nodeId: number, visitid: string, disableExtUpdate?: boolean, body: IVisitUpdateActionVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_Action implements IIbssApiClientV1_V1_ByNodeid_Visits_ByVisitid_Action
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, visitid: string, disableExtUpdate?: boolean, body: IVisitUpdateActionVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.disableExtUpdate) { queryParts.push(`disableExtUpdate=${encodeURIComponent(options.disableExtUpdate)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v1/${options.nodeId}/Visits/${options.visitid}/action?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV1_V1_ByNodeid_VisitsDailySummary
{

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV1_V1_ByNodeid_VisitsDailySummary implements IIbssApiClientV1_V1_ByNodeid_VisitsDailySummary
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.orderBy) { queryParts.push(`$orderBy=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/${options.nodeId}/VisitsDailySummary?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IAuthenticateRequest
{
    Username?: string;
    Password?: string;

}

export interface IBookingPartyPostModel
{
    Booking_Id?: string | null;
    Booking_Start?: string;
    Booking_End?: string;
    Booking_Participant_Email?: string | null;
    Booking_Participant_Name?: string | null;
    Booking_Participant_Organisation?: string | null;
    Booking_Resource_Id?: string | null;
    Booking_Visitor?: number;
    Booking_Participant_Type?: number;
    Booking_Participant_CheckedIn?: number;
    Booking_IsVisitor?: number;

}

export interface IBookingPartyPutModel
{
    Booking_Participant_Email?: string | null;

}

export type Client = 'None' | 'Admin';

export interface ISpaceBookRequest
{
    Node_Id?: number;
    Space_Layout?: string | null;
    SpaceId?: string;
    Start?: string;
    End?: string;
    Name?: string | null;
    Description?: string | null;
    AllDay?: number;
    IsPrivate?: number;
    Booking_Parties?: string | null;
    Booking_Parties_Visitors?: string | null;
    OnBehalfOf?: string | null;
    BookingAutoCheckin?: number;
    DisableExtUpdate?: boolean;
    Meta_Ext_Booking_Id?: string | null;
    Booking_Host_Name?: string | null;
    Booking_Host_Email?: string | null;
    AddOnlineMeetingLink?: number;
    Booking_Attendance?: number;

}

export interface IUpdateBookingModel
{
    Space_Layout?: string | null;
    StartTime?: string | null;
    EndTime?: string | null;
    PartyCount?: number | null;
    BookingName?: string | null;
    BookingDescription?: string | null;
    AllDay?: number | null;
    Private?: number | null;
    Organisation?: string | null;
    Booking_Parties?: string | null;
    Booking_Parties_Visitors?: string | null;
    DisableExtUpdate?: boolean;
    Meta_Ext_Booking_Id?: string | null;
    OnBehalfOf?: string | null;
    Booking_Host_Name?: string | null;
    Booking_Host_Email?: string | null;
    AddOnlineMeetingLink?: number;

}

export interface IBookingsSearchModel
{
    UserName?: string[] | null;
    When?: string | null;
    EndTime?: string | null;

}

export interface IBuildingKPICreate
{
    KPIType?: number;
    Units?: string | null;
    Label?: string | null;
    MaximumCount?: number;
    BuildingKPI_Limit1?: number;
    BuildingKPI_Limit2?: number;
    BuildingKPI_Text0?: string | null;
    BuildingKPI_Text1?: string | null;
    BuildingKPI_Text2?: string | null;
    BuildingKPI_Value?: number;
    ValueURI?: string | null;
    Icon?: string | null;
    ActionLabel?: string | null;
    ActionURI?: string | null;

}

export interface IBuildingKPIUpdate
{
    KPIType?: number | null;
    Units?: string | null;
    Label?: string | null;
    MaximumCount?: string | null;
    BuildingKPI_Limit1?: number | null;
    BuildingKPI_Limit2?: number | null;
    BuildingKPI_Text0?: string | null;
    BuildingKPI_Text1?: string | null;
    BuildingKPI_Text2?: string | null;
    BuildingKPI_Value?: number | null;
    ValueURI?: string | null;
    Icon?: string | null;
    ActionLabel?: string | null;
    ActionURI?: string | null;

}

export interface ICostCodePostModel
{
    Cost_Code?: string | null;
    Cost_Code_IsEnabled?: number;
    Cost_Code_Description?: string | null;
    Cost_Code_Type?: number;
    Cost_Code_Start_Date?: string | null;
    Cost_Code_End_Date?: string | null;
    Cost_Code_Source?: string | null;

}

export interface ICostCodeUpdateModel
{
    Cost_Code?: string | null;
    Cost_Code_IsEnabled?: number | null;
    Cost_Code_Description?: string | null;
    Cost_Code_Type?: number | null;
    Cost_Code_Start_Date?: string | null;
    Cost_Code_End_Date?: string | null;
    Cost_Code_Source?: string | null;

}

export interface IPostDevice
{
    Signage_Id?: number;
    Space_Id?: string | null;
    Device_Type?: number;
    Device_Code?: number | null;
    Device_Mode?: number;
    Device_Auth_Error?: string | null;
    Device_General_Error?: string | null;
    Device_OEM_Mode?: number;
    Device_OEM_Client_ImageURI?: string | null;
    Device_OEM_Brand_ImageURI?: string | null;
    Device_Config?: string | null;

}

export interface IUpdateModel
{
    Signage_Id?: number | null;
    Space_Id?: string | null;
    Device_Type?: number | null;
    Device_Code?: number | null;
    Device_Mode?: number | null;
    Device_Auth_Error?: string | null;
    Device_General_Error?: string | null;
    Device_OEM_Mode?: number | null;
    Device_OEM_Client_ImageURI?: string | null;
    Device_OEM_Brand_ImageURI?: string | null;
    Device_MAC?: string | null;
    Device_IP?: string | null;
    Signage_Mode?: number | null;
    Signage_Orientation?: number | null;
    Signage_Show_Bldg_Name?: number | null;
    Schedule_Config?: string | null;
    Lobby_Config?: string | null;
    Floor_Config?: string | null;
    Zone_Config?: string | null;
    VM_Config?: string | null;
    Meta_Loc_X_m?: number | null;
    Meta_Loc_Y_m?: number | null;
    ImageURI?: string | null;
    Device_Config?: string | null;

}

export interface ICommandRequestEntity
{
    Node_Id?: number;
    Command?: string | null;
    Parameter?: string | null;
    Delay?: number;

}

export interface IDeviceStatusUpdate
{
    Device_Property?: string | null;
    Device_Value?: string | null;

}

export interface ICreateEnvSensor
{
    Meta_Loc_X_m?: number;
    Meta_Loc_Y_m?: number;
    Env_Sensor_Id?: string | null;
    Env_Zone_Id?: number;
    Env_Sensor_Name?: string | null;
    Meta_RESET_Enabled?: number;
    Env_Sensor_IsEnabled?: number;
    Env_Temperature?: number;
    Env_Humidity?: number;
    Env_CO?: number;
    Env_CO2?: number;
    Env_PM25?: number;
    Env_PM10?: number;
    Env_TVOC?: number;
    Env_Sound_Level?: number;
    Env_Light_Level?: number;
    Env_Battery_Level?: number;
    IAQ_Status?: number;
    Env_Temperature_Status?: number;
    Env_Temperature_Range?: number;
    Env_Humidity_Status?: number;
    Env_Humidity_Range?: number;
    Env_CO_Status?: number;
    Env_CO2_Status?: number;
    Env_PM25_Status?: number;
    Env_PM10_Status?: number;
    Env_TVOC_Status?: number;
    Env_Sound_Level_Status?: number;
    Env_Sound_Level_Range?: number;
    Env_Light_Level_Status?: number;
    Env_Light_Level_Range?: number;
    Env_Battery_Level_Status?: number;

}

export interface IEnvSensorUpdateModel
{
    Meta_Loc_X_m?: number | null;
    Meta_Loc_Y_m?: number | null;
    Env_Zone_Id?: number | null;
    Env_Sensor_Name?: string | null;
    Meta_RESET_Enabled?: number | null;
    Env_Sensor_IsEnabled?: number | null;
    Env_Temperature?: number | null;
    Env_Humidity?: number | null;
    Env_CO?: number | null;
    Env_CO2?: number | null;
    Env_PM25?: number | null;
    Env_PM10?: number | null;
    Env_TVOC?: number | null;
    Env_Sound_Level?: number | null;
    Env_Light_Level?: number | null;
    Env_Battery_Level?: number | null;
    IAQ_Status?: number | null;
    Env_Temperature_Status?: number | null;
    Env_Temperature_Range?: number | null;
    Env_Humidity_Status?: number | null;
    Env_Humidity_Range?: number | null;
    Env_CO_Status?: number | null;
    Env_CO2_Status?: number | null;
    Env_PM25_Status?: number | null;
    Env_PM10_Status?: number | null;
    Env_TVOC_Status?: number | null;
    Env_Sound_Level_Status?: number | null;
    Env_Sound_Level_Range?: number | null;
    Env_Light_Level_Status?: number | null;
    Env_Light_Level_Range?: number | null;
    Env_Battery_Level_Status?: number | null;

}

export interface ICreateEnvironmentalZone
{
    Node_Id?: number;
    Env_Zone_Name?: string | null;
    Env_Zone_IsEnabled?: number | null;

}

export interface ICreateEnvironmentalZonePutRequest
{
    Env_Zone_Id?: number;
    Node_Id?: number;
    Env_Zone_Name?: string | null;
    Env_Zone_IsEnabled?: number | null;

}

export interface IEquipmentCreateVM
{
    Equip_Id?: string | null;
    ImageURI?: string | null;
    Space_Id?: string | null;
    Meta_Loc_X_m?: number;
    Meta_Loc_Y_m?: number;
    Meta_Loc_Zone?: string | null;
    Meta_Bookable?: number;
    Equip_Name?: string | null;
    Equip_Class?: string | null;
    Equip_Type?: string | null;
    Equip_IsEnabled?: number;
    Meta_Ext_CAFM_System?: number;
    Meta_Ext_CAFM_Id?: string | null;
    Meta_Loc_Height?: number;
    Meta_Loc_Fixed?: number;
    Equip_Comm_By?: string | null;
    Equip_Comm_Date?: string;
    Equip_Install_By?: string | null;
    Equip_Install_Date?: string;
    Equip_Serviced_By?: string | null;
    Equip_Serviced_Date?: string;
    Equip_Maint_Interval_Hrs?: number;
    Equip_Tag_No?: string | null;
    Equip_Serial_No?: string | null;
    Equip_Mfr?: string | null;
    MAC_Address?: string | null;
    IP_Address?: string | null;
    Equip_Last_Status_Change?: string;
    Equip_Last_Updated?: string;
    Store_Space_Id?: string | null;
    Equip_Status?: string | null;
    Equip_UI_Colour?: string | null;
    Equip_Status_Text?: string | null;
    Equip_Category?: string | null;

}

export interface IEquipmentBookingModel
{
    StartDate?: string;
    EndDate?: string;

}

export interface IAvailableEquipment
{
    EquipmentType?: string | null;
    StartDate?: string | null;
    EndDate?: string | null;

}

export interface IDeviceRegistration
{
    Platform?: string | null;
    Handle?: string | null;
    Tags?: string[] | null;

}

export interface ICreateNotification
{
    ImageURI?: string | null;
    Notification_Title?: string | null;
    Notification_Priority?: string | null;
    Classification?: string | null;
    SubClassfication?: string | null;
    Notification_Message?: string | null;
    Notification_Short_Message?: string | null;
    Available_From?: string;
    Expiry_Date?: string;
    Notification_Reminders?: string | null;
    Notification_Type?: number;
    Notification_Status?: string | null;
    Notification_User_Email?: string | null;

}

export interface IUpdateNotification
{
    ImageURI?: string | null;
    Notification_Title?: string | null;
    Notification_Priority?: string | null;
    Classification?: string | null;
    SubClassfication?: string | null;
    Notification_Message?: string | null;
    Notification_Short_Message?: string | null;
    Available_From?: string | null;
    Expiry_Date?: string | null;
    Notification_Reminders?: string | null;
    Notification_Type?: number | null;
    Notification_Status?: string | null;
    Notification_User_Email?: string | null;

}

export interface IParameterCreate
{
    Parameter_Name?: string | null;
    Parameter_Value?: string | null;
    Parameter_Label?: string | null;
    Parameter_Section?: string | null;
    Parameter_Units?: string | null;
    Parameter_Description?: string | null;
    Parameter_Type?: string | null;
    Parameter_Scalar_LowLimit?: string | null;
    Parameter_Scalar_HighLimit?: string | null;
    Parameter_Toggle_Values?: string | null;
    Parameter_Toggle_ValueCount?: number | null;

}

export type EventType = 'None' | 'Parameters' | 'TaskTypes' | 'TaskCategories' | 'SupportedVersions' | 'Nodes' | 'CateringMenu' | 'TaskStates' | 'SpaceStates' | 'BuildingKPIs' | 'ResolverCategories' | 'SpaceInformation' | 'SpacesSpaceInformation' | 'SpaceTypeBookingPolicies' | 'AppliesToRoles' | 'BookingPolicies' | 'Spaces' | 'CateringMenuTemplate';

export type TraceLevel = 'All' | 'Verbose' | 'Debug' | 'Normal' | 'Warning' | 'Error' | 'Critical';

export type IbssErrorCategoryId = 'User' | 'Information' | 'Telemetry' | 'Warning' | 'Error' | 'Security';

export interface ISignageVM
{
    ImageURI?: string | null;
    Meta_Loc_X_m?: number | null;
    Meta_Loc_Y_m?: number | null;
    Signage_Mode?: number | null;
    Signage_Orientation?: number | null;
    Signage_Show_Bldg_Name?: number | null;
    Schedule_Config?: string | null;
    Lobby_Config?: string | null;
    Floor_Config?: string | null;
    Zone_Config?: string | null;
    VM_Config?: string | null;

}

export interface ISpaceCateringPostVM
{
    ImageURI?: string | null;
    Space_Catering_Title?: string | null;
    Space_Catering_Message?: string | null;
    Space_Catering_IsEnabled?: number;
    Space_Catering_IsPreBookable?: number;
    Space_Catering_IsRoomService?: number;
    Space_Catering_Section?: string | null;
    Space_Catering_Cost?: number;
    Space_Catering_Short_Message?: string | null;

}

export interface ISpaceCateringUpdateVM
{
    ImageURI?: string | null;
    Space_Catering_Title?: string | null;
    Space_Catering_Message?: string | null;
    Space_Catering_IsEnabled?: number | null;
    Space_Catering_IsPreBookable?: number | null;
    Space_Catering_IsRoomService?: number | null;
    Space_Catering_Section?: string | null;
    Space_Catering_Cost?: number | null;
    Space_Catering_Short_Message?: string | null;

}

export interface ISearchRequest
{
    Spaceclass?: string | null;
    SpaceType?: string | null;
    WorkType?: string | null;
    Floor?: string | null;
    Zone?: string | null;
    When?: string | null;
    EndTime?: string | null;
    AnyDate?: boolean;
    OnlyAvailable?: boolean;
    RequireAV?: boolean;
    RequireCatering?: boolean;
    Env_Temperature_Range?: number | null;
    Env_Sound_Level_Range?: number | null;
    MetaServReqsHearing?: number | null;
    MetaServReqsPresentation?: number | null;
    Meta_Loc_X_m?: number | null;
    Meta_Loc_Y_m?: number | null;
    Meta_Loc_Radius?: number | null;

}

export interface IGetBookingsModel
{
    StartDate?: string;
    EndDate?: string;

}

export interface ISpaceOccupancy
{
    SpaceId?: string | null;
    SensorAreaId?: string | null;
    OccupancyCount?: number | null;
    TLInCount?: number | null;
    TLOutCount?: number | null;
    Timestamp?: string;

}

export interface ISpaceSetPointVM
{
    Space_AV_Disp_SP?: number | null;
    Space_AV_Source_SP?: number | null;
    Space_AV_Vol_SP?: number | null;
    Space_Blind_SP?: number | null;
    Space_Light_SP?: number | null;
    Space_Temp_SP?: number | null;

}

export interface ISpaceUpdateActionVM
{
    Space_IsEnabled?: number | null;
    Space_IsCheckedIn?: number | null;
    Space_IsCheckedOut?: number | null;
    Space_IsReserved?: number | null;
    BookingOwnerEmail?: string | null;
    BookingOwnerPIN?: string | null;

}

export interface ISpaceStatePost
{
    Space_State_Id?: string | null;
    Space_State_Name?: string | null;
    Space_State_Pre_Header?: string | null;
    Space_State_Header?: string | null;
    Space_State_Body?: string | null;
    Space_State_L1CTA_P?: string | null;
    Space_State_L1CTA_S?: string | null;
    Space_State_L1CTA_T?: string | null;
    Space_State_Show_Space?: number | null;
    Space_State_Show_Fault?: number | null;
    Space_State_Show_Controls?: number | null;
    Space_State_Show_Info?: number | null;
    Space_State_Show_Schedule?: number | null;
    Space_State_Show_Booking?: number | null;
    Space_State_UI_Colour?: string | null;
    Space_State_Text?: string | null;
    Space_State_Icon?: string | null;
    Space_State_Value0?: string | null;
    Space_State_Value1?: string | null;
    Space_State_L1CTA_P_Command?: string | null;
    Space_State_L1CTA_S_Command?: string | null;
    Space_State_L1CTA_T_Command?: string | null;
    Space_State_Validation_Field?: string | null;
    Space_State_Alternate?: string | null;
    Space_State_Show_Custom?: number | null;

}

export interface ISpaceStateUpdate
{
    Space_State_Id?: string | null;
    Space_State_Name?: string | null;
    Space_State_Pre_Header?: string | null;
    Space_State_Header?: string | null;
    Space_State_Body?: string | null;
    Space_State_L1CTA_P?: string | null;
    Space_State_L1CTA_S?: string | null;
    Space_State_L1CTA_T?: string | null;
    Space_State_Show_Space?: number | null;
    Space_State_Show_Fault?: number | null;
    Space_State_Show_Controls?: number | null;
    Space_State_Show_Info?: number | null;
    Space_State_Show_Schedule?: number | null;
    Space_State_Show_Booking?: number | null;
    Space_State_UI_Colour?: string | null;
    Space_State_Text?: string | null;
    Space_State_Icon?: string | null;
    Space_State_Value0?: string | null;
    Space_State_Value1?: string | null;
    Space_State_L1CTA_P_Command?: string | null;
    Space_State_L1CTA_S_Command?: string | null;
    Space_State_L1CTA_T_Command?: string | null;
    Space_State_Validation_Field?: string | null;
    Space_State_Alternate?: string | null;
    Space_State_Show_Custom?: number | null;

}

export interface ISpaceZonePost
{
    Meta_Loc_Zone?: string | null;
    Node_Name?: string | null;

}

export interface ISupportedVersionPostModel
{
    Supported_Version_OS?: number;
    Supported_Version_Module?: number;
    Supported_Version?: string | null;
    Supported_Version_Date?: string;

}

export interface ISupportedVersionPutModel
{
    Supported_Version_OS?: number | null;
    Supported_Version_Module?: number | null;
    Supported_Version?: string | null;
    Supported_Version_Date?: string | null;

}

export type SpaceTypes = 'Desk' | 'SitStandDesk' | 'SpecialistDesk' | 'MeetingRoom' | 'MeetingBooth' | 'PhoneBooth' | 'FocusBooth' | 'Touchdown' | 'CollaborationSpace' | 'Office' | 'PrivateRoom' | 'VCRoom' | 'Boardroom' | 'SharedQuietRoom' | 'LectureTheatre' | 'InformalLounge' | 'TrainingRoom' | 'BenchSeating' | 'Storage' | 'PrintRoom' | 'Lockers' | 'Stationery' | 'PostRoom' | 'Reception' | 'WaitingLounge' | 'Restaurant' | 'Cafe' | 'Kitchenette' | 'Bar' | 'LiftLobby' | 'TreatmentRoom' | 'BOHOffice' | 'Gym' | 'Changing' | 'UnisexWCs' | 'MaleWC' | 'FemaleWC' | 'AccessibleWC' | 'BikeStore' | 'FirstAid' | 'MothersRoom' | 'Security' | 'CoatStorage' | 'IndoorGarden' | 'PrayerRoom' | 'Prayer' | 'CleaningStation' | 'Riser' | 'EquipmentRoom' | 'WellnessRoom' | 'Pantry' | 'WaterPoint' | 'ParkingSpace' | 'ParcelLocker';

export interface ITaskCategoriesUpdate
{
    Task_Category_IsEnabled?: number | null;
    ImageURI?: string | null;
    Task_Category_Id?: string | null;
    Task_Category_Name?: string | null;

}

export interface ITaskCreate
{
    Space_Id?: string | null;
    Task_Category_Id?: number;
    Task_Type_Id?: number;
    Task_Description?: string | null;
    Task_Priority?: number | null;
    Equipment_Id?: string | null;
    Booking_Id?: string | null;
    Booking_Start?: string | null;
    Is_Catering_Request?: boolean;
    Catering_Service_Time?: string | null;
    Catering_Clearing_Time?: string | null;
    Catering_Attendees?: number;
    Is_Catering_Clear?: boolean;
    Catering_Notes?: string | null;
    DisableExtUpdate?: boolean;
    Cost_Code_Allocation?: ICostCodeAllocation[] | null;

}

export interface ICostCodeAllocation
{
    Cost_Code?: string | null;
    Cost_Code_Id?: string | null;
    Allocation?: number;

}

export interface ITaskUpdateVM
{
    Task_Priority?: number | null;
    Task_Description?: string | null;
    Task_Resolve_Description?: string | null;
    Catering_Attendees?: number | null;
    Catering_Service_Time?: string | null;
    Catering_Clearing_Time?: string | null;
    Catering_Notes?: string | null;
    Cost_Code_Allocation?: ICostCodeAllocation[] | null;

}

export interface ITasksAssign
{
    Resolver_Id?: string | null;

}

export interface ITaskReAllocate
{
    Resolver_Id?: string | null;
    Priority?: number;

}

export interface ITaskResolve
{
    TaskResolveDescription?: string | null;

}

export interface ITaskPriority
{
    Priority?: number;

}

export interface ITaskComment
{
    Message?: string | null;
    UserName?: string | null;

}

export interface ITaskStatePostModel
{
    Task_State_Name?: string | null;
    Task_State_Header?: string | null;
    Task_State_Body?: string | null;
    Task_State_Value0?: string | null;
    Task_State_Value1?: string | null;
    Task_State_L1CTA_P?: string | null;
    Task_State_L1CTA_P_Command?: string | null;
    Task_State_L1CTA_S?: string | null;
    Task_State_L1CTA_S_Command?: string | null;
    Task_State_L1CTA_T?: string | null;
    Task_State_L1CTA_T_Command?: string | null;
    Task_State_Icon?: string | null;
    Task_State_Show_Space?: number;
    Task_State_Show_Notes?: number;
    Task_State_Alternate?: string | null;
    Task_State_Id?: string | null;

}

export interface ITaskStateUpdate
{
    Task_State_Id?: string | null;
    Task_State_Name?: string | null;
    Task_State_Header?: string | null;
    Task_State_Body?: string | null;
    Task_State_Value0?: string | null;
    Task_State_Value1?: string | null;
    Task_State_L1CTA_P?: string | null;
    Task_State_L1CTA_P_Command?: string | null;
    Task_State_L1CTA_S?: string | null;
    Task_State_L1CTA_S_Command?: string | null;
    Task_State_L1CTA_T?: string | null;
    Task_State_L1CTA_T_Command?: string | null;
    Task_State_Icon?: string | null;
    Task_State_Show_Space?: number | null;
    Task_State_Show_Notes?: number | null;
    Task_State_Alternate?: string | null;

}

export interface ITaskTypeCreateModel
{
    Task_Category_Id?: number;
    Task_Type_Id?: number;
    Task_Type_Name?: string | null;
    Task_Type_Priority?: number;
    Task_Type_Resolve_Duration?: number;
    Task_Type_Priority_Resolve_Duration?: number;
    Task_IsDefault_Space_Clean_Task?: number;
    Task_Type_IsEnabled?: number;
    Space_Type?: string | null;
    Task_Type_Add_Details?: number;
    Task_IsDefault_Catering_Task?: number;
    Task_Type_Requires_Cost_Code?: number;
    Equip_Type?: string | null;
    Meta_Ext_Task_Type_Id?: string | null;

}

export interface ITaskTypeUpdateModel
{
    Task_Category_Id?: number | null;
    Task_Type_Id?: number | null;
    Task_Type_Name?: string | null;
    Task_Type_Priority?: number | null;
    Task_Type_Resolve_Duration?: number | null;
    Task_Type_Priority_Resolve_Duration?: number | null;
    Task_IsDefault_Space_Clean_Task?: number | null;
    Task_Type_IsEnabled?: number | null;
    Space_Type?: string | null;
    Task_Type_Add_Details?: number | null;
    Task_IsDefault_Catering_Task?: number | null;
    Task_Type_Requires_Cost_Code?: number | null;
    Equip_Type?: string | null;
    Meta_Ext_Task_Type_Id?: string | null;

}

export interface IRequestModel
{
    Username?: string | null;
    StartDate?: string;
    EndDate?: string;
    Proximity?: number;
    PostOccupancyPeriod?: number;

}

export interface INotificationStatus
{
    Notification_Read_Status?: NotificationReadStatus;

}

export type NotificationReadStatus = 'Read' | 'Unread';

export interface IUserPrefUpdateModel
{
    HubPrefs?: IHubPrefs;
    SecurityPrefs?: ISecurityPrefs;
    NotificationPrefs?: INotificationPreference;
    PrivacyPrefs?: IPrivacyPreference;
    CalendarPrefs?: ICalendarPreference;
    EnvironmentPrefs?: IEnvironmentPreference;
    WorkinghoursPrefs?: IWorkingHoursPreference;
    SearchPrefs?: ISearchPreference;
    DiagnosticsPrefs?: IDiagnosticsPreference;
    LanguagePrefs?: ILanguagePrefs;
    Nodes?: IBuilding[] | null;
    FavouriteColleagues?: IFavouriteColleague[] | null;
    DefaultBookingCostCodes?: ICostCodeAttribute[] | null;
    DefaultCateringCostCodes?: ICostCodeAttribute[] | null;

}

export interface IHubPrefs
{
    StartApp?: string | null;
    TimeMode?: string | null;

}

export interface ISecurityPrefs
{
    Pin?: string | null;

}

export interface INotificationPreference
{
    Safety?: number | null;
    Visitors?: number | null;
    Tasks?: number | null;
    Bookings?: number | null;
    Buildings?: number | null;
    DeviceRegistrationId?: string | null;
    Platform?: string | null;
    Handle?: string | null;
    BuildingsPrefs?: IBuildingsPrefs[] | null;

}

export interface IBuildingsPrefs
{
    NodeId?: number | null;
    Value?: number | null;

}

export interface IPrivacyPreference
{
    ShareLocation?: number | null;

}

export interface ICalendarPreference
{
    SyncCalendar?: number | null;

}

export interface IEnvironmentPreference
{
    Temperature?: number | null;
    SoundLevel?: number | null;

}

export interface IWorkingHoursPreference
{
    UserStartTime?: string | null;
    UserEndTime?: string | null;

}

export interface ISearchPreference
{
    DefaultSearchResults?: string | null;
    DefaultBuilding?: number | null;

}

export interface IDiagnosticsPreference
{
    Logging?: number | null;

}

export interface ILanguagePrefs
{
    Language?: string | null;

}

export interface IBuilding
{
    NodeId?: number;
    DefaultFloor?: number;
    DefaultZone?: string | null;
    FavouriteSpaces?: string[] | null;
    FavouriteAmenities?: string[] | null;
    FavouriteEquipment?: string[] | null;
    DefaultFilter?: IDefaultFilter[] | null;

}

export interface IDefaultFilter
{
    EventType_Id?: string | null;
    Filter_Id?: string | null;

}

export interface IFavouriteColleague
{
    Email?: string | null;
    FirstName?: string | null;
    LastName?: string | null;

}

export interface ICostCodeAttribute
{
    CostCodeID?: string | null;
    CostCodeName?: string | null;
    CostCodeDescription?: string | null;
    CostCodeApportionment?: string | null;

}

export interface INotificationsPrefModel
{
    Safety?: number | null;
    Visitors?: number | null;
    Tasks?: number | null;
    Bookings?: number | null;
    Buildings?: number | null;
    DeviceRegistrationId?: string | null;
    Platform?: string | null;
    Handle?: string | null;
    BuildingsPrefs?: IBuildingsPrefs[] | null;

}

export interface IPrivacyPrefsModel
{
    ShareLocation?: number | null;

}

export interface IEnvironmentPrefsModel
{
    Temperature?: number | null;
    SoundLevel?: number | null;

}

export interface IWorkingHoursPrefsModel
{
    UserStartTime?: string | null;
    UserEndTime?: string | null;

}

export interface ISearchPrefsModel
{
    DefaultSearchResults?: string | null;
    DefaultBuilding?: number | null;

}

export interface ISyncCalenderPrefsModel
{
    SyncCalender?: number;

}

export interface IDiagnosticsPrefsModel
{
    DiagnosticsPrefs?: number;

}

export interface IUserLocationRequestModel
{
    Location?: string | null;

}

export interface IAccessPass
{
    BuildingId?: string | null;
    Type?: string | null;
    PassKey?: string | null;

}

export interface IUserPin
{
    PIN?: string | null;
    UserName?: string | null;

}

export interface IPostVisitVM
{
    Space_Id?: string | null;
    Space_Name?: string | null;
    Visitor_First_Name?: string | null;
    Visitor_Last_Name?: string | null;
    Visitor_Email?: string | null;
    Visitor_Company?: string | null;
    Visit_Host_Name?: string | null;
    Visit_Host_Email?: string | null;
    Visit_Start_Date?: string;
    Visit_End_Date?: string;
    Visit_Approval_Comments?: string | null;
    DisableExtUpdate?: boolean;
    Visit_Pacs_Id?: string | null;

}

export interface IPutVisitVM
{
    Space_Id?: string | null;
    Space_Name?: string | null;
    Visitor_First_Name?: string | null;
    Visitor_Last_Name?: string | null;
    Visitor_Email?: string | null;
    Visitor_Company?: string | null;
    Visit_Host_Name?: string | null;
    Visit_Host_Email?: string | null;
    Visit_Start_Date?: string | null;
    Visit_End_Date?: string | null;
    Visit_IsCheckedIn?: number | null;
    Visit_IsNoShow?: number | null;
    Visit_IsCheckedOut?: number | null;
    Visit_Approval_Comments?: string | null;
    Visitor_Dietary_Pref?: number | null;
    Visit_IsDenied?: number | null;
    DisableExtUpdate?: boolean;
    Visit_Pacs_Id?: string | null;

}

export interface IVisitUserUpdatesVM
{
    Visitor_First_Name?: string | null;
    Visitor_Last_Name?: string | null;
    Visitor_Company?: string | null;
    Visitor_Dietary_Pref?: number | null;
    Visit_Save_Info?: number | null;

}

export interface IVisitUpdateActionVM
{
    Visit_IsApproved?: number | null;
    Visit_IsCancelled?: number | null;
    Visit_IsCheckedIn?: number | null;
    Visit_IsCheckedOut?: number | null;
    Visit_IsDenied?: number | null;
    Visit_Approval_Comments?: string | null;

}
